[
  {
    "scenarioId": 1,
    "language": "ko-KR",
    "translations": {
      "context": "당신의 팀 직속 부하인 Joe가 지속적으로 프로젝트 마감일을 놓치고 있습니다. 이로 인해 전체 팀 성과와 프로젝트 일정에 영향을 미치고 있습니다.\n\n당신은 Joe에게 이것이 문제라고 알렸고, 상황을 논의하기 위해 그와 미팅을 잡았습니다.",
      "keyDetails": [
        {
          "text": "Joe는 최근 여러 마감일을 놓쳤습니다"
        },
        {
          "text": "예를 들어, 그는 최근 보고서를 일주일 늦게 완료했고, 최근 팀원의 프레젠테이션에 이틀 늦게 자료를 제출했습니다"
        },
        {
          "text": "이 문제는 팀 성과와 일정에 악영향을 미치고 있습니다"
        },
        {
          "text": "Joe는 과거에 좋은 성과를 보여왔습니다"
        },
        {
          "text": "목표는 Joe가 개선하도록 돕는 것이지, 처벌하는 것이 아닙니다"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "대화를 시작하고 미팅의 목적을 설명합니다"
        },
        {
          "text": "놓친 마감일과 그 영향에 대한 구체적인 예시를 제공합니다"
        },
        {
          "text": "Joe의 관점과 그가 직면한 어려움을 경청합니다"
        },
        {
          "text": "Joe가 개선할 수 있도록 다음 단계를 협력하여 정합니다. 예: Joe의 프로젝트 우선순위 설정을 도와줍니다"
        },
        {
          "text": "명확한 기대치와 후속 조치를 설정합니다"
        }
      ],
      "objectives": [
        {
          "text": "긍정적인 업무 관계를 유지하면서 Joe의 성과 문제를 다룹니다"
        },
        {
          "text": "Joe의 시간 관리 개선을 위한 다음 단계를 협력하여 합의합니다"
        }
      ]
    }
  },
  {
    "scenarioId": 1,
    "language": "ja-JP",
    "translations": {
      "context": "あなたのチームの直属の部下であるジョーは、プロジェクトの締め切りに遅れることが続いています。これがチーム全体のパフォーマンスとプロジェクトのスケジュールに影響を与えています。\n\nあなたはこの問題についてジョーに伝え、状況を話し合うためにミーティングを予定しました。",
      "keyDetails": [
        {
          "text": "ジョーは最近、いくつかの締め切りに遅れました"
        },
        {
          "text": "例えば、彼は最新のレポートを1週間遅れて完成させ、最近チームメンバーのプレゼンテーションへの入力を2日遅れて提出しました"
        },
        {
          "text": "この問題はチームのパフォーマンスとスケジュールに影響を与えています"
        },
        {
          "text": "ジョーは過去には優秀なパフォーマーでした"
        },
        {
          "text": "目標はジョーの改善を助けることであり、罰することではありません"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "会話を始め、ミーティングの目的を説明する"
        },
        {
          "text": "締め切りに遅れた具体的な例とその影響を提示する"
        },
        {
          "text": "ジョーの視点や彼が直面している課題を聞く"
        },
        {
          "text": "ジョーの改善を助けるための次のステップ（例：プロジェクトの優先順位付けを手伝うなど）を協力して考える"
        },
        {
          "text": "明確な期待値とフォローアップの手順を設定する"
        }
      ],
      "objectives": [
        {
          "text": "良好な信頼関係を維持しながら、ジョーのパフォーマンス問題に対処する"
        },
        {
          "text": "ジョーの時間管理を改善するための次のステップに協力して合意する"
        }
      ]
    }
  },
  {
    "scenarioId": 1,
    "language": "cmn-CN",
    "translations": {
      "context": "乔（Joe）是你团队的一名直属下属，一直无法按时完成项目。这已经影响了整个团队的绩效和项目进度。\n\n你已经让乔知道这是一个问题，并安排了一次会议和他讨论这个情况。",
      "keyDetails": [
        {
          "text": "乔最近错过了几次截止日期"
        },
        {
          "text": "例如：他晚了一周才完成最新的报告，最近给团队成员的演示文稿提供内容也晚了两天"
        },
        {
          "text": "这个问题正在影响团队绩效和时间表"
        },
        {
          "text": "乔过去表现一直很好"
        },
        {
          "text": "目的是帮助乔改进，而不是惩罚"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开启对话并解释会议的目的"
        },
        {
          "text": "提供错过截止日期的具体例子及其影响"
        },
        {
          "text": "倾听乔的观点以及他面临的任何挑战"
        },
        {
          "text": "共同商讨帮助乔改进的后续步骤，例如帮助乔进行项目优先级排序"
        },
        {
          "text": "设定明确的期望和后续跟进步骤"
        }
      ],
      "objectives": [
        {
          "text": "在保持积极工作关系的同时解决乔的绩效问题"
        },
        {
          "text": "共同商定后续步骤以帮助乔改善时间管理"
        }
      ]
    }
  },
  {
    "scenarioId": 1,
    "language": "en-AU",
    "translations": {
      "context": "Joe, a direct report on your team, has been consistently missing project deadlines. This is impacting overall team performance and project timelines.  \n\nYou've let Joe know this is a problem and have scheduled a meeting with him to discuss the situation.",
      "keyDetails": [
        {
          "text": "Joe has missed several recent deadlines"
        },
        {
          "text": "For example: he finished his latest report a week late, and he recently inputted into a team member's presentation two days late"
        },
        {
          "text": "The issue is impacting team performance and timelines"
        },
        {
          "text": "Joe has been a good performer in the past"
        },
        {
          "text": "The goal is to help Joe improve, not to punish"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Open the conversation and explain the purpose of the meeting"
        },
        {
          "text": "Provide specific examples of missed deadlines and their impact"
        },
        {
          "text": "Listen to Joe's perspective and any challenges he's facing"
        },
        {
          "text": "Collaborate on next steps to help Joe improve e.g. helping Joe with prioritisation of his projects"
        },
        {
          "text": "Set clear expectations and follow-up steps"
        }
      ],
      "objectives": [
        {
          "text": "Address Joe's performance issue while maintaining a positive working relationship"
        },
        {
          "text": "Collaboratively agree next steps to help Joe improve his time management"
        }
      ]
    }
  },
  {
    "scenarioId": 1,
    "language": "en-IN",
    "translations": {
      "context": "Joe, a direct report on your team, has been consistently missing project deadlines. This is impacting overall team performance and project timelines.  \n\nYou've let Joe know this is a problem and have scheduled a meeting with him to discuss the situation.",
      "keyDetails": [
        {
          "text": "Joe has missed several recent deadlines"
        },
        {
          "text": "For example: he finished his latest report a week late, and he recently inputted into a team member's presentation two days late"
        },
        {
          "text": "The issue is impacting team performance and timelines"
        },
        {
          "text": "Joe has been a good performer in the past"
        },
        {
          "text": "The goal is to help Joe improve, not to punish"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Open the conversation and explain the purpose of the meeting"
        },
        {
          "text": "Provide specific examples of missed deadlines and their impact"
        },
        {
          "text": "Listen to Joe's perspective and any challenges he's facing"
        },
        {
          "text": "Collaborate on next steps to help Joe improve e.g. helping Joe with prioritisation of his projects"
        },
        {
          "text": "Set clear expectations and follow-up steps"
        }
      ],
      "objectives": [
        {
          "text": "Address Joe's performance issue while maintaining a positive working relationship"
        },
        {
          "text": "Collaboratively agree next steps to help Joe improve his time management"
        }
      ]
    }
  },
  {
    "scenarioId": 1660,
    "language": "ko-KR",
    "translations": {
      "context": "당신 팀의 수석 매니저인 올리버는 기대했던 이사(Director) 승진을 받지 못했습니다. 그는 이 직책의 유력한 후보로 널리 거론되었으며 긍정적인 소식을 기대하고 있었습니다. 당신은 이 예상치 못한 결정을 전달하고 매우 어려울 것으로 예상되는 대화를 관리하기 위해 이 회의를 잡았습니다.",
      "keyDetails": [
        {
          "text": "올리버는 유력한 후보였음에도 불구하고 이사 승진을 받지 못했습니다"
        },
        {
          "text": "그는 유능한 수석 매니저이지만, 심사 위원단은 전략적 비전과 이해관계자 영향력에서 부족한 점을 확인했습니다"
        },
        {
          "text": "당신은 이 예상치 못한 결과에 대한 그의 충격과 좌절을 다루어야 합니다"
        },
        {
          "text": "엇갈린 메시지와 경력 경로에 대한 그의 타당한 우려를 해결해야 합니다"
        },
        {
          "text": "이사 승진 준비를 위한 구체적이고 측정 가능한 단계를 제시해야 합니다"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "이것이 예상치 못한 어려운 소식임을 인정하며 솔직하게 대화를 시작하십시오"
        },
        {
          "text": "그의 강력한 후보 자격을 인정하면서 승진 결정을 명확하게 전달하십시오"
        },
        {
          "text": "이전의 긍정적인 피드백과 모순되지 않도록 이사 수준에서 부족한 점에 대한 구체적이고 확실한 예를 제공하십시오"
        },
        {
          "text": "엇갈린 신호와 승진이 실제로 가능한지에 대한 직접적인 질문에 답하십시오"
        },
        {
          "text": "미래의 성장과 개발을 위한 계획을 함께 수립하십시오"
        }
      ],
      "objectives": [
        {
          "text": "감정적인 반응을 관리하고 신뢰를 회복하면서 예상치 못한 승진 결정을 전달하십시오"
        },
        {
          "text": "승진 준비와 연계된 명확하고 실행 가능한 개발 피드백을 제공하십시오"
        }
      ]
    }
  },
  {
    "scenarioId": 1660,
    "language": "ja-JP",
    "translations": {
      "context": "あなたのチームのシニアマネージャーであるオリバーは、期待していたディレクターへの昇進を受けられませんでした。彼はこのポジションの有力候補と広く見なされており、良いニュースを期待していました。あなたはこの予期せぬ決定を伝え、非常に困難になるであろう会話に対処するためにこのミーティングを設定しました。",
      "keyDetails": [
        {
          "text": "オリバーは有力候補でしたが、ディレクターへの昇進を受けられませんでした"
        },
        {
          "text": "彼は優秀なシニアマネージャーですが、選考委員会は戦略的ビジョンとステークホルダーへの影響力にギャップがあることを確認しました"
        },
        {
          "text": "あなたはこの予期せぬ結果に対する彼のショックと不満に対処しなければなりません"
        },
        {
          "text": "一貫性のないメッセージやキャリアの軌跡に関する彼の正当な懸念に対処してください"
        },
        {
          "text": "ディレクターになるための具体的かつ測定可能なステップを提示してください"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "これが予期せぬ厳しいニュースであることを認め、単刀直入に話を切り出す"
        },
        {
          "text": "彼の強力な適性を認めつつ、昇進の決定を明確に伝える"
        },
        {
          "text": "以前の肯定的なフィードバックと矛盾しないように、ディレクターレベルでのギャップについて具体的かつ明確な例を挙げる"
        },
        {
          "text": "一貫性のないシグナルや、昇進が本当に可能なのかという直接的な質問に答える"
        },
        {
          "text": "将来の成長と能力開発のための計画を協力して作成する"
        }
      ],
      "objectives": [
        {
          "text": "感情的な反応を管理し信頼を再構築しながら、予期せぬ昇進の決定を伝える"
        },
        {
          "text": "昇進の準備状況に関連した、明確で実行可能な能力開発のフィードバックを提供する"
        }
      ]
    }
  },
  {
    "scenarioId": 1660,
    "language": "cmn-CN",
    "translations": {
      "context": "奥利弗（Oliver）是你团队的一名高级经理，他没有获得期待中的总监（Director）晋升。大家普遍认为他是这个职位的热门人选，他自己也期待着好消息。你安排这次会议是为了传达这个意想不到的决定，并处理这场可能会非常艰难的对话。",
      "keyDetails": [
        {
          "text": "尽管奥利弗是众望所归的人选，但他没有获得总监晋升"
        },
        {
          "text": "他是一位出色的高级经理，但评审小组发现他在战略远见和利益相关者影响力方面存在差距"
        },
        {
          "text": "你必须处理他对这一意外结果的震惊和沮丧"
        },
        {
          "text": "解决他对信息混乱和职业轨迹的合理担忧"
        },
        {
          "text": "列出为晋升总监做准备的具体、可衡量的步骤"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "直接开场，承认这将是意想不到且艰难的消息"
        },
        {
          "text": "清晰地传达晋升决定，同时认可他的强大竞争力"
        },
        {
          "text": "提供总监层级差距的具体、实在的例子，避免与之前的正面反馈相矛盾"
        },
        {
          "text": "回答关于信号混乱以及晋升是否真正可能的直接问题"
        },
        {
          "text": "共同制定未来成长和发展的计划"
        }
      ],
      "objectives": [
        {
          "text": "传达意想不到的晋升决定，同时管理情绪反应并重建信任"
        },
        {
          "text": "提供与晋升准备度挂钩的清晰、可操作的发展反馈"
        }
      ]
    }
  },
  {
    "scenarioId": 1660,
    "language": "en-AU",
    "translations": {
      "context": "Oliver, a Senior Manager on your team, hasn't received the Director promotion they were expecting to get. They were widely considered the front-runner for this position and were expecting positive news. You've scheduled this meeting to deliver the unexpected decision and manage what will likely be a very difficult conversation.",
      "keyDetails": [
        {
          "text": "Oliver didn't receive the Director promotion despite being the expected choice"
        },
        {
          "text": "They're a strong Senior Manager but the panel identified gaps in strategic vision and stakeholder influence"
        },
        {
          "text": "You must handle their shock and frustration at this unexpected outcome"
        },
        {
          "text": "Address their legitimate concerns about mixed messages and their career trajectory"
        },
        {
          "text": "Outline specific, measurable steps for Director readiness"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Open directly, acknowledging this will be unexpected and difficult news"
        },
        {
          "text": "Clearly communicate the promotion decision while recognising their strong candidacy"
        },
        {
          "text": "Provide specific, concrete examples of Director-level gaps without contradicting previous positive feedback"
        },
        {
          "text": "Address direct questions about mixed signals and whether advancement is genuinely possible"
        },
        {
          "text": "Collaboratively develop a plan for future growth and development"
        }
      ],
      "objectives": [
        {
          "text": "Communicate the unexpected promotion decision while managing emotional reactions and rebuilding trust"
        },
        {
          "text": "Provide clear, actionable development feedback linked to promotion readiness"
        }
      ]
    }
  },
  {
    "scenarioId": 1660,
    "language": "en-IN",
    "translations": {
      "context": "Oliver, a Senior Manager on your team, hasn't received the Director promotion they were expecting to get. They were widely considered the front-runner for this position and were expecting positive news. You've scheduled this meeting to deliver the unexpected decision and manage what will likely be a very difficult conversation.",
      "keyDetails": [
        {
          "text": "Oliver didn't receive the Director promotion despite being the expected choice"
        },
        {
          "text": "They're a strong Senior Manager but the panel identified gaps in strategic vision and stakeholder influence"
        },
        {
          "text": "You must handle their shock and frustration at this unexpected outcome"
        },
        {
          "text": "Address their legitimate concerns about mixed messages and their career trajectory"
        },
        {
          "text": "Outline specific, measurable steps for Director readiness"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Open directly, acknowledging this will be unexpected and difficult news"
        },
        {
          "text": "Clearly communicate the promotion decision while recognising their strong candidacy"
        },
        {
          "text": "Provide specific, concrete examples of Director-level gaps without contradicting previous positive feedback"
        },
        {
          "text": "Address direct questions about mixed signals and whether advancement is genuinely possible"
        },
        {
          "text": "Collaboratively develop a plan for future growth and development"
        }
      ],
      "objectives": [
        {
          "text": "Communicate the unexpected promotion decision while managing emotional reactions and rebuilding trust"
        },
        {
          "text": "Provide clear, actionable development feedback linked to promotion readiness"
        }
      ]
    }
  },
  {
    "scenarioId": 1303,
    "language": "ko-KR",
    "translations": {
      "context": "당신은 딜로이트(Deloitte)의 수석 매니저입니다. 주요하고 매우 적극적인 고객 이해관계자인 올리버와 프로젝트 점검 통화가 예정되어 있습니다. 업무는 전반적으로 잘 진행되고 있으며 그와 강력하고 협력적인 관계를 맺고 있습니다. 캘린더 초대 제목은 단순히 \"프로젝트 진행 상황 및 새로운 아이디어 점검(Catch up on project progress & new ideas)\"입니다.",
      "keyDetails": [
        {
          "text": "프로젝트는 엄격한 업무 기술서(SOW)에 따라 시간과 예산에 맞춰 진행되고 있습니다. 그러나 프로젝트 마진이 빠듯하여 상당한 비청구 작업을 위한 여지가 없습니다."
        },
        {
          "text": "올리버는 딜로이트의 열정적인 옹호자입니다. 그는 이 관계를 진정한 파트너십으로 보고 항상 가치를 더할 새로운 방법을 생각하는데, 이는 때때로 합의된 범위를 벗어난 아이디어를 제안하는 것으로 이어집니다."
        },
        {
          "text": "참여 파트너(Engagement Partner)는 당신을 신뢰하며, 필요한 경우 변경 주문 협상을 포함하여 프로젝트 범위와 상업적 측면을 직접 관리할 수 있는 권한을 부여했습니다."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "강력한 파트너십과 현재까지의 프로젝트 성공을 인정하며 따뜻하게 통화를 시작하십시오."
        },
        {
          "text": "고객의 새로운 아이디어를 적극적으로 경청하고, 요청 내용과 근본적인 비즈니스 가치를 완전히 이해하기 위해 진단 질문을 하십시오."
        },
        {
          "text": "요청의 가치를 인정한 다음, 프로젝트의 기존 범위와 상업적 측면으로 대화를 부드럽고 투명하게 전환하십시오."
        },
        {
          "text": "새로운 분석을 수행할 수 있는 옵션(예: 변경 주문, 다른 작업 범위 축소, 나중을 위한 단계적 진행)을 함께 모색하십시오."
        },
        {
          "text": "명확한 진행 경로에 동의하고, 다음 단계를 확정하며, 고객의 장기적인 성공에 대한 헌신을 강화하십시오."
        }
      ],
      "objectives": [
        {
          "text": "현재 업무 기술서(SOW) 범위를 벗어나는 요청을 관리하여 프로젝트의 상업적 무결성을 유지하십시오."
        },
        {
          "text": "범위 논의를 상호 합의 가능한 결과로 협력적으로 이끌어감으로써 고객 관계를 보존하고 강화하십시오."
        }
      ]
    }
  },
  {
    "scenarioId": 1303,
    "language": "ja-JP",
    "translations": {
      "context": "あなたはデロイトのシニアマネージャーです。重要かつ非常に熱心なクライアントのステークホルダーであるオリバーと、プロジェクトの進捗確認の電話会議が予定されています。エンゲージメントは概ね順調に進んでおり、彼とは強固で協力的な関係を築いています。カレンダーの招待タイトルは単に「プロジェクトの進捗と新しいアイデアについてのキャッチアップ」となっています。",
      "keyDetails": [
        {
          "text": "プロジェクトは厳格な作業範囲記述書（SOW）に基づき、スケジュール通り、予算内で進行しています。しかし、プロジェクトの利益率は厳しく、多額の未請求作業を行う余裕はありません。"
        },
        {
          "text": "オリバーはデロイトの熱心な支持者です。彼はこの関係を真のパートナーシップと見なしており、常に付加価値を高める新しい方法を考えていますが、その結果、合意された範囲外のアイデアを提案することがあります。"
        },
        {
          "text": "エンゲージメントパートナーはあなたを信頼しており、必要に応じて変更指示（チェンジオーダー）の交渉を含め、プロジェクトの範囲と採算性を直接管理する権限をあなたに与えています。"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "強固なパートナーシップとこれまでのプロジェクトの成功を認め、温かく電話を始める。"
        },
        {
          "text": "クライアントの新しいアイデアを積極的に傾聴し、診断的な質問をして、要望とその根本的なビジネス価値を完全に理解する。"
        },
        {
          "text": "要望の価値を認めた上で、会話をプロジェクトの既存の範囲と採算性の話題へと穏やかかつ透明性を持って移行させる。"
        },
        {
          "text": "新しい分析をどのように実現できるか、選択肢（例：変更指示、他の作業の範囲縮小、後のフェーズへの移行）を協力して検討する。"
        },
        {
          "text": "明確な進行パスに合意し、次のステップを固め、クライアントの長期的な成功へのコミットメントを強調する。"
        }
      ],
      "objectives": [
        {
          "text": "現在の作業範囲記述書（SOW）の範囲外となる要望を管理し、プロジェクトの商業的な健全性を維持する。"
        },
        {
          "text": "範囲に関する議論を相互に合意できる結果へと協力して導くことで、クライアントとの関係を維持・強化する。"
        }
      ]
    }
  },
  {
    "scenarioId": 1303,
    "language": "cmn-CN",
    "translations": {
      "context": "你是德勤（Deloitte）的一名高级经理。你安排了与奥利弗（Oliver）进行项目检查通话，他是一位关键且高度敬业的客户利益相关者。项目总体进展顺利，你与他建立了稳固、协作的关系。日历邀请的标题很简单：“跟进项目进度及新想法。”",
      "keyDetails": [
        {
          "text": "项目在严格的工作说明书（SOW）管辖下按时、按预算进行。然而，项目利润率很低，没有任何空间进行大量的无偿工作。"
        },
        {
          "text": "奥利弗是德勤的热情拥护者。他将这种关系视为真正的合作伙伴关系，并总是思考增加价值的新方法，这有时会导致他提出超出商定范围的想法。"
        },
        {
          "text": "项目合伙人信任你，并已授权你直接管理项目范围和商务事宜，包括在必要时协商变更订单。"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "热情地开始通话，认可稳固的合作伙伴关系以及项目迄今为止的成功。"
        },
        {
          "text": "积极倾听客户的新想法，提出诊断性问题以充分理解请求及其潜在的商业价值。"
        },
        {
          "text": "承认该请求的价值，然后温和且透明地将对话转向项目现有的范围和商务事宜。"
        },
        {
          "text": "共同探讨如何实现新分析的选项（例如：变更订单、缩减其他工作范围、分阶段在后期进行）。"
        },
        {
          "text": "就明确的前进路径达成一致，确定后续步骤，并加强你对客户长期成功的承诺。"
        }
      ],
      "objectives": [
        {
          "text": "通过管理超出当前工作说明书（SOW）范围的请求，维护项目的商业完整性。"
        },
        {
          "text": "通过协作引导范围讨论达成双方同意的结果，从而维护并加强客户关系。"
        }
      ]
    }
  },
  {
    "scenarioId": 1303,
    "language": "en-AU",
    "translations": {
      "context": "You are a Senior Manager at Deloitte. You have a scheduled project check-in call with Oliver, a key and highly engaged client stakeholder. The engagement is generally tracking well and you have a strong, collaborative relationship with him. The calendar invitation is simply titled \"Catch up on project progress & new ideas.\"",
      "keyDetails": [
        {
          "text": "The project is on-time and on-budget, governed by a strict Statement of Work (SOW). However, the project margins are tight, leaving no room for significant unbilled work."
        },
        {
          "text": "Oliver is an enthusiastic champion for Deloitte. He sees the relationship as a true partnership and is always thinking of new ways to add value, which sometimes leads him to suggest ideas that are outside the agreed-upon scope."
        },
        {
          "text": "The Engagement Partner trusts you and has empowered you to manage the project scope and commercials directly, including negotiating change orders if necessary."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Open the call warmly, acknowledging the strong partnership and the project's success to date."
        },
        {
          "text": "Listen actively to the client's new idea, asking diagnostic questions to fully understand the request and its underlying business value."
        },
        {
          "text": "Acknowledge the value of the request, then gently and transparently pivot the conversation to the project's existing scope and commercials."
        },
        {
          "text": "Collaboratively explore options for how the new analysis could be accomplished (e.g., change order, de-scoping other work, phasing it for later)."
        },
        {
          "text": "Agree on a clear path forward, solidifying the next steps and reinforcing your commitment to the client's long-term success."
        }
      ],
      "objectives": [
        {
          "text": "Uphold the commercial integrity of the project by managing requests that fall outside the current Statement of Work."
        },
        {
          "text": "Preserve and strengthen the client relationship by collaboratively navigating the scope discussion to a mutually agreeable outcome."
        }
      ]
    }
  },
  {
    "scenarioId": 1303,
    "language": "en-IN",
    "translations": {
      "context": "You are a Senior Manager at Deloitte. You have a scheduled project check-in call with Oliver, a key and highly engaged client stakeholder. The engagement is generally tracking well and you have a strong, collaborative relationship with him. The calendar invitation is simply titled \"Catch up on project progress & new ideas.\"",
      "keyDetails": [
        {
          "text": "The project is on-time and on-budget, governed by a strict Statement of Work (SOW). However, the project margins are tight, leaving no room for significant unbilled work."
        },
        {
          "text": "Oliver is an enthusiastic champion for Deloitte. He sees the relationship as a true partnership and is always thinking of new ways to add value, which sometimes leads him to suggest ideas that are outside the agreed-upon scope."
        },
        {
          "text": "The Engagement Partner trusts you and has empowered you to manage the project scope and commercials directly, including negotiating change orders if necessary."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Open the call warmly, acknowledging the strong partnership and the project's success to date."
        },
        {
          "text": "Listen actively to the client's new idea, asking diagnostic questions to fully understand the request and its underlying business value."
        },
        {
          "text": "Acknowledge the value of the request, then gently and transparently pivot the conversation to the project's existing scope and commercials."
        },
        {
          "text": "Collaboratively explore options for how the new analysis could be accomplished (e.g., change order, de-scoping other work, phasing it for later)."
        },
        {
          "text": "Agree on a clear path forward, solidifying the next steps and reinforcing your commitment to the client's long-term success."
        }
      ],
      "objectives": [
        {
          "text": "Uphold the commercial integrity of the project by managing requests that fall outside the current Statement of Work."
        },
        {
          "text": "Preserve and strengthen the client relationship by collaboratively navigating the scope discussion to a mutually agreeable outcome."
        }
      ]
    }
  },
  {
    "scenarioId": 2480,
    "language": "nl-NL",
    "translations": {
      "context": "Je bent de leidinggevende van Wim, een buschauffeur. Je ontmoet hem op het eindpunt van zijn rit, direct nadat hij tijdens zijn dienst fysiek is aangevallen.\n\nJe doel is om eerste opvang te bieden en ervoor te zorgen dat hij zich veilig en gehoord voelt in dit eerste gesprek.",
      "keyDetails": [
        {
          "text": "Wim is fysiek aangevallen en heeft licht hoofdletsel opgelopen tijdens zijn avonddienst"
        },
        {
          "text": "Het incident is zeer kort geleden gebeurd; hij is nog steeds erg geschrokken en emotioneel"
        },
        {
          "text": "Hij greep in bij een conflict, wat in strijd is met de officiële dienstinstructies"
        },
        {
          "text": "Wim is een ervaren werknemer die al eerder veiligheidszorgen over deze lijn heeft gemeld"
        },
        {
          "text": "Dit gesprek draait puur om opvang; bespreek geen procedurele of disciplinaire zaken"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Begin met te informeren naar Wims directe fysieke en emotionele toestand"
        },
        {
          "text": "Nodig hem uit om in zijn eigen woorden te vertellen wat er is gebeurd, zonder hem te onderbreken"
        },
        {
          "text": "Erken zijn gevoelens van woede, angst en frustratie en toon hier begrip voor"
        },
        {
          "text": "Bespreek opties voor directe praktische steun, zoals vervoer naar huis en medische controle"
        },
        {
          "text": "Vat de vervolgstappen samen en verzeker hem van de blijvende steun vanuit het bedrijf"
        }
      ],
      "objectives": [
        {
          "text": "Luister actief naar Wims verhaal over het incident en geef hem de ruimte om zijn emoties te uiten"
        },
        {
          "text": "Bied directe praktische steun en sluit het gesprek af met duidelijke, geruststellende vervolgstappen"
        }
      ]
    }
  },
  {
    "scenarioId": 1,
    "language": "fr-FR",
    "translations": {
      "context": "Joe, un subordonné direct de votre équipe, a manqué de façon répétée les échéances de ses projets. Cela a un impact sur la performance globale de l'équipe et sur les délais des projets.\n\nVous avez planifié un point avec Joe pour discuter de ces échéances manquées.",
      "keyDetails": [
        {
          "text": "Joe a manqué plusieurs échéances récentes"
        },
        {
          "text": "Par exemple : il a terminé son dernier rapport avec une semaine de retard, et il a récemment contribué à la présentation d'un membre de l'équipe avec deux jours de retard"
        },
        {
          "text": "Le problème impacte la performance et les délais de l'équipe"
        },
        {
          "text": "Joe a été performant par le passé"
        },
        {
          "text": "L'objectif est d'aider Joe à s'améliorer, pas de le punir"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objectif de la réunion"
        },
        {
          "text": "Fournir des exemples précis d'échéances manquées et leur impact"
        },
        {
          "text": "Écouter le point de vue de Joe et les difficultés auxquelles il est confronté"
        },
        {
          "text": "Collaborer sur les prochaines étapes pour aider Joe à s'améliorer, par exemple en l'aidant à prioriser ses projets"
        },
        {
          "text": "Fixer des attentes claires et des étapes de suivi"
        }
      ],
      "objectives": [
        {
          "text": "Aborder le problème de performance de Joe tout en maintenant une relation de travail positive"
        },
        {
          "text": "Convenir ensemble des prochaines étapes pour aider Joe à améliorer sa gestion du temps"
        }
      ]
    }
  },
  {
    "scenarioId": 2,
    "language": "fr-FR",
    "translations": {
      "context": "L'un de vos collaborateurs directs, Morgan, rencontre des conflits persistants avec un autre membre de l'équipe, Taylor. Ces conflits affectent le moral et la productivité de l'équipe. Vous avez planifié un entretien avec Morgan pour discuter de la situation.",
      "keyDetails": [
        {
          "text": "Morgan pense que Taylor vole son travail et le présente comme le sien"
        },
        {
          "text": "Le conflit affecte la performance au travail et la motivation de Morgan"
        },
        {
          "text": "Vous avez également remarqué que le conflit affecte la dynamique de l'équipe"
        },
        {
          "text": "Vous avez organisé la réunion pour comprendre le point de vue de Morgan "
        },
        {
          "text": "Vous voulez aider Morgan à résoudre le problème avec Taylor "
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objet de la réunion"
        },
        {
          "text": "Permettre à Morgan d'exprimer ses frustrations et ses préoccupations avec des exemples précis"
        },
        {
          "text": "Discuter de l'impact du conflit sur le travail de Morgan et sur l'équipe"
        },
        {
          "text": "Explorer les idées de Morgan pour améliorer la situation et présenter des solutions potentielles"
        },
        {
          "text": "Collaborer à l'élaboration d'un plan d'action avec des attentes claires et des étapes de suivi"
        }
      ],
      "objectives": [
        {
          "text": "Comprendre la nature du conflit entre Morgan et Taylor, et l'impact qu'il a sur Morgan "
        },
        {
          "text": "Écouter activement les préoccupations de Morgan et orienter la conversation vers la recherche de solutions constructives"
        }
      ]
    }
  },
  {
    "scenarioId": 3,
    "language": "fr-FR",
    "translations": {
      "context": "Jordan, un collaborateur direct, vous a récemment informé par e-mail qu'il traverse un divorce. Vous avez programmé un appel avec lui pour discuter de cette question délicate.",
      "keyDetails": [
        {
          "text": "Jordan vous a récemment informé de son divorce par e-mail"
        },
        {
          "text": "Il n'a pas fourni plus de détails sur la situation"
        },
        {
          "text": "Il s'agit d'une question personnelle sensible qui peut affecter le travail"
        },
        {
          "text": "La confidentialité et le niveau de confort de Jordan concernant le partage d'informations sont importants"
        },
        {
          "text": "Un plan de communication et de soutien continus peut être nécessaire"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation avec empathie et soutien"
        },
        {
          "text": "Discuter des préoccupations immédiates de Jordan concernant sa capacité à se concentrer sur le travail"
        },
        {
          "text": "Explorer les impacts potentiels sur la performance au travail ou sur l'emploi du temps"
        },
        {
          "text": "Discuter des préférences en matière de confidentialité et de partage d'informations"
        },
        {
          "text": "Établir un plan de communication et de soutien continus"
        }
      ],
      "objectives": [
        {
          "text": "Exprimer de l'empathie et du soutien pour la situation de Jordan"
        },
        {
          "text": "Comprendre les préoccupations immédiates et l'impact potentiel sur le travail"
        }
      ]
    }
  },
  {
    "scenarioId": 4,
    "language": "fr-FR",
    "translations": {
      "context": "Cleo, votre collaboratrice directe, a montré une baisse notable de la qualité de son travail, en particulier dans son attention aux détails. Cela a entraîné des erreurs dans les rapports et les présentations, ce qui nuit à la réputation et à l'efficacité de l'équipe. \n\nVous avez programmé un entretien avec Cleo pour en discuter, mais vous ne lui avez pas encore précisé l'objet de cette réunion.",
      "keyDetails": [
        {
          "text": "La qualité du travail de Cleo a décliné, surtout au niveau de l'attention portée aux détails"
        },
        {
          "text": "Par exemple, sa présentation de la semaine dernière comportait des erreurs ; son rapport d'il y a quelques semaines contenait plusieurs erreurs numériques"
        },
        {
          "text": "Ces problèmes impactent la réputation et l'efficacité de l'équipe \n"
        },
        {
          "text": "Cleo a toujours été très performante et constitue un membre précieux de l'équipe"
        },
        {
          "text": "Vous souhaitez aider Cleo à s'améliorer et à retrouver ses standards habituels"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Engager la conversation et expliquer l'objet de l'entretien"
        },
        {
          "text": "Donner des exemples précis de problèmes de qualité et leurs conséquences"
        },
        {
          "text": "Écouter le point de vue de Cleo et les difficultés qu'elle rencontre"
        },
        {
          "text": "Collaborer à l'élaboration d'un plan d'amélioration"
        },
        {
          "text": "Fixer des attentes claires et les prochaines étapes de suivi"
        }
      ],
      "objectives": [
        {
          "text": "Aborder le problème de qualité du travail tout en maintenant un climat de soutien"
        },
        {
          "text": "Comprendre les causes profondes de cette baisse de performance"
        }
      ]
    }
  },
  {
    "scenarioId": 5,
    "language": "fr-FR",
    "translations": {
      "context": "Ollie, votre subordonné direct, a eu de mauvais résultats lors des réunions avec les clients, ce qui a entraîné des moments gênants et des malentendus. Cependant, son travail en dehors des réunions reste excellent. Ollie est confiant et sociable, croyant en sa capacité à improviser, mais il sous-estime l'importance de la préparation des réunions. \n\nVous avez programmé une réunion avec Ollie pour discuter de la situation. Ollie sait que la discussion que vous avez prévue porte sur la réunion client d'hier.",
      "keyDetails": [
        {
          "text": "Les performances d'Ollie en réunion client ont été médiocres."
        },
        {
          "text": "Par exemple, lors de la réunion d'hier, il a mal répondu à des questions simples de clients. Lors de la réunion de la semaine dernière, il n'a pas défini d'ordre du jour clair au début de la réunion."
        },
        {
          "text": "Son travail en dehors des réunions reste excellent"
        },
        {
          "text": "Ollie est confiant et sociable, préférant improviser"
        },
        {
          "text": "Il sous-estime l'importance de la préparation des réunions"
        },
        {
          "text": "L'objectif est d'améliorer les performances en réunion sans affecter les autres travaux\n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objectif de la réunion"
        },
        {
          "text": "Fournir des exemples spécifiques de problèmes en réunion et leur impact"
        },
        {
          "text": "Reconnaître les points forts d'Ollie dans son travail hors réunion"
        },
        {
          "text": "Discuter de l'importance de la préparation des réunions"
        },
        {
          "text": "Collaborer sur des stratégies pour améliorer les performances en réunion"
        }
      ],
      "objectives": [
        {
          "text": "Aborder les problèmes de performance en réunion tout en reconnaissant les points forts d'Ollie\n"
        },
        {
          "text": "Élaborer un plan pour améliorer les performances d'Ollie en réunion"
        }
      ]
    }
  },
  {
    "scenarioId": 6,
    "language": "fr-FR",
    "translations": {
      "context": "Mark, votre collaborateur direct, a récemment rendu un travail qui ne correspond pas aux attentes et contient plusieurs erreurs. Malgré ces problèmes, Mark a une attitude positive et souhaite sincèrement s'améliorer. \n\nVous avez organisé une réunion avec Mark pour discuter de ce travail. Vous ne lui avez pas précisé l'objet de l'entretien, mais vous pensez qu'il s'en doute.",
      "keyDetails": [
        {
          "text": "Le travail récent de Mark comportait plusieurs problèmes"
        },
        {
          "text": "Par exemple, il a inclus des recherches non pertinentes ; l'analyse était incomplète ; et la structure de la présentation était confuse"
        },
        {
          "text": "La qualité de son travail était en dessous des standards attendus"
        },
        {
          "text": "Mark a une attitude très positive et aime son travail"
        },
        {
          "text": "Il a envie d'améliorer ses performances"
        },
        {
          "text": "Vous voulez préserver l'enthousiasme de Mark tout en traitant les points qui posent problème"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Entamer la conversation et souligner l'attitude positive de Mark"
        },
        {
          "text": "Expliquer l'objectif de la réunion et les préoccupations liées à sa performance"
        },
        {
          "text": "Donner des exemples précis d'erreurs et leurs conséquences"
        },
        {
          "text": "Écouter le point de vue de Mark et les difficultés qu'il rencontre"
        },
        {
          "text": "Collaborer pour définir un plan d'amélioration"
        }
      ],
      "objectives": [
        {
          "text": "Traiter la récente baisse de performance tout en valorisant l'attitude positive de Mark"
        },
        {
          "text": "Discuter ensemble de pistes pour l'aider à améliorer la qualité de son travail"
        }
      ]
    }
  },
  {
    "scenarioId": 7,
    "language": "fr-FR",
    "translations": {
      "context": "Amelia, une subordonnée directe ambitieuse, a outrepassé les limites de son rôle. Elle a envoyé des informations à votre supérieur sans votre approbation ou connaissance préalable, et a pris en charge des parties du projet d'un autre membre de l'équipe. \n\nVous avez programmé une réunion avec Amelia pour discuter de la situation. Vous n'avez pas prévenu Amelia de l'objet de la réunion. ",
      "keyDetails": [
        {
          "text": "Amelia a envoyé des informations directement à votre supérieur sans que vous le sachiez"
        },
        {
          "text": "Elle a pris en charge des parties du projet d'un autre membre de l'équipe (Walt) sans autorisation"
        },
        {
          "text": "Vous devez clarifier les limites de son rôle"
        },
        {
          "text": "Vous voulez renforcer les canaux de communication appropriés"
        },
        {
          "text": "Vous voulez recentrer l'attention d'Amelia sur ses responsabilités principales"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objet de la réunion"
        },
        {
          "text": "Fournir des exemples précis où Amelia a outrepassé ses limites"
        },
        {
          "text": "Clarifier les attentes liées au rôle et les canaux de communication appropriés"
        },
        {
          "text": "Écouter le point de vue et les motivations d'Amelia"
        },
        {
          "text": "Développer ensemble un plan pour une collaboration appropriée"
        }
      ],
      "objectives": [
        {
          "text": "Aborder le comportement d'Amelia qui outrepasse les limites de son rôle\n"
        },
        {
          "text": "Clarifier les attentes liées au rôle et les canaux de communication appropriés "
        }
      ]
    }
  },
  {
    "scenarioId": 8,
    "language": "fr-FR",
    "translations": {
      "context": "Jasmin, un membre de votre équipe, a fait l'objet d'une plainte pour harcèlement. La politique RH de l'entreprise exige que vous lui communiquiez cette information sensible, que vous lui expliquiez que les détails ne peuvent pas être partagés à ce stade, et que vous l'informiez qu'elle doit s'absenter pendant l'enquête RH. Vous avez planifié une réunion avec Jasmin pour l'informer de la situation.",
      "keyDetails": [
        {
          "text": "Une plainte pour harcèlement a été déposée contre Jasmin"
        },
        {
          "text": "Des détails supplémentaires sur la plainte ne peuvent pas être partagés avec Jasmin à ce stade"
        },
        {
          "text": "Jasmin doit s'absenter du travail pendant l'enquête, avec maintien de son plein salaire"
        },
        {
          "text": "Vous ne savez pas actuellement combien de temps l'enquête va durer"
        },
        {
          "text": "Vous devez souligner l'importance de suivre le processus RH"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objet de la réunion"
        },
        {
          "text": "Énoncer clairement l'existence de la plainte pour harcèlement et la nécessité de s'absenter"
        },
        {
          "text": "Expliquer les limites concernant le partage des détails"
        },
        {
          "text": "Écouter et répondre aux préoccupations immédiates de Jasmin"
        },
        {
          "text": "Offrir du soutien"
        }
      ],
      "objectives": [
        {
          "text": "Informer Jasmin de la plainte pour harcèlement tout en maintenant soutien et professionnalisme"
        },
        {
          "text": "Expliquer clairement la situation et les prochaines étapes"
        }
      ]
    }
  },
  {
    "scenarioId": 9,
    "language": "fr-FR",
    "translations": {
      "context": "Dennis, un employé vedette de votre équipe qui obtient systématiquement d'excellents résultats, a de faibles compétences interpersonnelles. Il est souvent impoli, abrasif et peu disposé à aider ses collègues, particulièrement ceux qu'il perçoit comme moins compétents. \n\nVous avez programmé une réunion avec Dennis pour aborder la situation.",
      "keyDetails": [
        {
          "text": "Dennis est un employé très performant qui obtient d'excellents résultats"
        },
        {
          "text": "Il a de faibles compétences interpersonnelles, se montrant souvent impoli et abrasif "
        },
        {
          "text": "Par exemple, il a refusé d'aider des membres de l'équipe sur des tâches pour lesquelles il possède une expertise ; il s'est montré impoli et dédaigneux lorsque quelqu'un de l'équipe a suggéré une amélioration de sa présentation "
        },
        {
          "text": "Son comportement affecte la dynamique d'équipe et la collaboration"
        },
        {
          "text": "L'amélioration de son comportement est cruciale pour son évolution de carrière"
        },
        {
          "text": "L'objectif est de maintenir sa performance tout en renforçant ses compétences relationnelles"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Entamer la conversation en soulignant les excellentes performances de Dennis"
        },
        {
          "text": "Donner des exemples précis de comportements problématiques et de leur impact (ex : refus d'aider des membres de l'équipe sur des tâches où il possède une expertise ; propos impolis et dédaigneux lorsque quelqu'un de l'équipe a suggéré une amélioration à sa présentation)"
        },
        {
          "text": "Expliquer l'importance des compétences interpersonnelles pour l'évolution de carrière"
        },
        {
          "text": "Écouter le point de vue de Dennis sur son comportement et sa façon de travailler"
        },
        {
          "text": "Définir ensemble des stratégies pour améliorer ses compétences interpersonnelles"
        }
      ],
      "objectives": [
        {
          "text": "Traiter les problèmes interpersonnels de Dennis tout en préservant son niveau élevé de performance et d'engagement"
        },
        {
          "text": "Discuter des prochaines étapes pour améliorer le comportement et les compétences de leadership de Dennis"
        }
      ]
    }
  },
  {
    "scenarioId": 10,
    "language": "fr-FR",
    "translations": {
      "context": "Une nouvelle politique de travail hybride exige que les employés soient au bureau au moins deux fois par semaine. Alex, l'un de vos collaborateurs directs, a travaillé entièrement à distance et ne s'est pas conformé à la politique. Vous avez abordé le sujet avec Alex par e-mail et avez planifié une réunion avec Alex pour discuter de la situation.",
      "keyDetails": [
        {
          "text": "La nouvelle politique exige une présence au bureau deux fois par semaine"
        },
        {
          "text": "Alex travaille entièrement à distance"
        },
        {
          "text": "Alex ne s'est pas conformé à la nouvelle politique"
        },
        {
          "text": "Vous devez vous assurer qu'Alex commence à venir au bureau deux fois par semaine"
        },
        {
          "text": "Maintenir une approche de soutien tout en appliquant la politique"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objectif de la réunion"
        },
        {
          "text": "Communiquer clairement la politique de travail hybride"
        },
        {
          "text": "Écouter les raisons pour lesquelles Alex ne vient pas au bureau"
        },
        {
          "text": "Aborder les préoccupations et discuter des avantages de la collaboration en personne"
        },
        {
          "text": "Élaborer de manière collaborative un plan pour la présence au bureau        \n"
        }
      ],
      "objectives": [
        {
          "text": "Traiter le non-respect de la politique tout en maintenant une relation de travail positive"
        },
        {
          "text": "Convenir avec Alex qu'elle doit commencer à venir au bureau deux jours par semaine"
        }
      ]
    }
  },
  {
    "scenarioId": 11,
    "language": "fr-FR",
    "translations": {
      "context": "Jim, un employé très performant de votre équipe, fait l'objet d'un licenciement économique en raison de réductions d'effectifs, avec effet immédiat. Cette décision n'est pas basée sur ses performances. Vous avez programmé cet entretien pour l'informer de son licenciement.",
      "keyDetails": [
        {
          "text": "Jim fait l'objet d'un licenciement économique en raison de réductions d'effectifs"
        },
        {
          "text": "La décision est effective immédiatement"
        },
        {
          "text": "Jim est un employé très performant, la décision n'est pas liée à ses performances"
        },
        {
          "text": "L'indemnité de licenciement correspond à un mois de salaire complet"
        },
        {
          "text": "Vous devez rester professionnel tout en gérant vos propres émotions"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": " Ouvrez la conversation et annoncez la nouvelle du licenciement clairement"
        },
        {
          "text": "Expliquez que la décision est due à des réductions d'effectifs, et non aux performances"
        },
        {
          "text": "Donnez des détails sur l'indemnité de licenciement "
        },
        {
          "text": "Exprimez votre reconnaissance pour les contributions de Jim"
        },
        {
          "text": "Répondez aux questions ou préoccupations immédiates que Jim pourrait avoir  "
        }
      ],
      "objectives": [
        {
          "text": "Communiquer la décision de licenciement de manière claire et professionnelle"
        },
        {
          "text": "Exprimer votre reconnaissance pour les contributions de Jim tout en annonçant la nouvelle difficile "
        }
      ]
    }
  },
  {
    "scenarioId": 12,
    "language": "fr-FR",
    "translations": {
      "context": "Joe, un collaborateur direct, est licencié en raison d'une insuffisance professionnelle persistante, avec effet immédiat. Vous avez eu plusieurs entretiens préalables avec Joe concernant ses performances, mais aucune amélioration n'a été constatée, d'où la décision de mettre fin à son contrat. Vous avez programmé une réunion pour informer Joe de la nouvelle.",
      "keyDetails": [
        {
          "text": "Joe est licencié pour insuffisance professionnelle persistante"
        },
        {
          "text": "La décision prend effet immédiatement"
        },
        {
          "text": "Vous avez eu plusieurs entretiens de performance avec Joe par le passé, mais aucune amélioration n'a été constatée"
        },
        {
          "text": "Joe sera rémunéré jusqu'à la fin du mois"
        },
        {
          "text": "Restez professionnel tout au long de cette conversation difficile"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Engager la conversation et annoncer la nouvelle clairement\n"
        },
        {
          "text": "Expliquer que la décision est due à des problèmes de performance persistants"
        },
        {
          "text": "Faire référence aux entretiens de performance passés"
        },
        {
          "text": "Fournir des détails sur l'indemnité de départ et les étapes suivantes"
        },
        {
          "text": "Répondre aux questions ou préoccupations immédiates de Joe"
        }
      ],
      "objectives": [
        {
          "text": "Communiquer la décision de licenciement de façon claire et professionnelle"
        },
        {
          "text": "Donner les informations nécessaires concernant l'indemnité de départ et la suite de la procédure"
        }
      ]
    }
  },
  {
    "scenarioId": 13,
    "language": "fr-FR",
    "translations": {
      "context": "Jordan, un employé de votre équipe, était extrêmement ivre lors d'une récente fête de travail, s'est comporté de manière inappropriée et a dû être renvoyé chez lui en taxi. Vous avez prévu une réunion avec Jordan pour aborder la situation.",
      "keyDetails": [
        {
          "text": "Jordan était extrêmement ivre lors d'une récente fête de travail et son comportement était inapproprié"
        },
        {
          "text": "Il s'est montré désagréable envers le personnel du bar et vous avez dû le renvoyer chez lui en taxi"
        },
        {
          "text": "Jordan traverse un divorce, ce qui peut l'affecter"
        },
        {
          "text": "Vous devez faire comprendre que ce comportement est inacceptable"
        },
        {
          "text": "Équilibrer fermeté et empathie compte tenu de la situation personnelle de Jordan"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objet de la réunion"
        },
        {
          "text": "Décrire le comportement de Jordan lors de la fête et son impact"
        },
        {
          "text": "Écouter le point de vue de Jordan et les éventuels problèmes personnels qu'il rencontre"
        },
        {
          "text": "Communiquer clairement les attentes pour son comportement futur"
        },
        {
          "text": "Offrir du soutien si nécessaire, tout en soulignant la gravité de la situation       "
        }
      ],
      "objectives": [
        {
          "text": "Aborder le comportement inapproprié de Jordan"
        },
        {
          "text": "Fixer des attentes claires pour sa conduite future tout en faisant preuve d'empathie  "
        }
      ]
    }
  },
  {
    "scenarioId": 14,
    "language": "fr-FR",
    "translations": {
      "context": "Joe, un membre de l'équipe, a été à plusieurs reprises en retard à divers engagements professionnels, notamment des appels vidéo, des journées au bureau et des réunions avec des clients. Bien que les retards ne soient généralement que de quelques minutes, ils nuisent à l'image de l'entreprise et font perdre du temps aux autres. \n\nVous avez planifié une réunion avec Joe pour discuter de la situation et vous l'avez prévenu qu'il s'agissait de sa ponctualité.",
      "keyDetails": [
        {
          "text": "Joe a été systématiquement en retard à ses engagements professionnels"
        },
        {
          "text": "Les retards varient de quelques minutes à 10 minutes "
        },
        {
          "text": "Par exemple, il a rejoint la réunion d'équipe avec 10 minutes de retard cette semaine ; il a rejoint une réunion client avec 5 minutes de retard hier"
        },
        {
          "text": "Son retard a un impact sur l'image de l'entreprise et sur le temps des autres"
        },
        {
          "text": "Vous devez comprendre les raisons de son retard"
        },
        {
          "text": "L'objectif est d'améliorer la ponctualité de Joe"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objet de la réunion"
        },
        {
          "text": "Fournir des exemples précis de retard et leur impact (par ex. faire attendre un client)"
        },
        {
          "text": "Écouter le point de vue de Joe et les raisons de son retard"
        },
        {
          "text": "Discuter de l'importance de la ponctualité"
        },
        {
          "text": "Développer en collaboration des stratégies pour améliorer la ponctualité"
        }
      ],
      "objectives": [
        {
          "text": "Traiter le retard chronique de Joe tout en maintenant une relation de travail positive"
        },
        {
          "text": "Élaborer un plan pour améliorer la ponctualité de Joe"
        }
      ]
    }
  },
  {
    "scenarioId": 15,
    "language": "fr-FR",
    "translations": {
      "context": "Lucas, un télétravailleur de votre équipe, a récemment été hors ligne et n'a pas répondu pendant les heures de travail, ce qui a causé des problèmes lors de demandes urgentes. Vous avez programmé une réunion avec Lucas pour aborder la situation.",
      "keyDetails": [
        {
          "text": "Lucas a été hors ligne et n'a pas répondu pendant les heures de travail"
        },
        {
          "text": "Par exemple, il n'a pas répondu la semaine dernière alors que vous aviez besoin de son avis avant une réunion le jour même. Il n'a pas non plus répondu de toute la matinée il y a quelques jours, même si son calendrier était libre.\n"
        },
        {
          "text": "Vous devez clarifier les attentes en matière de disponibilité "
        },
        {
          "text": "Comprendre le point de vue de Lucas sur le travail flexible"
        },
        {
          "text": "Trouver un équilibre entre flexibilité et réactivité  "
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objet de la réunion"
        },
        {
          "text": "Fournir des exemples précis de problèmes de disponibilité et leur impact"
        },
        {
          "text": "Écouter le point de vue de Lucas sur le travail flexible"
        },
        {
          "text": "Discuter de l'importance d'être joignable pendant les heures de présence obligatoire"
        },
        {
          "text": "Élaborer ensemble un plan pour améliorer la disponibilité        "
        }
      ],
      "objectives": [
        {
          "text": "Aborder les problèmes de disponibilité de Lucas et établir des attentes claires concernant la disponibilité en télétravail"
        },
        {
          "text": "S'accorder avec Lucas sur la manière dont il peut améliorer sa communication lorsqu'il travaille à distance "
        }
      ]
    }
  },
  {
    "scenarioId": 16,
    "language": "fr-FR",
    "translations": {
      "context": "Dom, un collaborateur direct, reprend le travail après plusieurs mois de congé parental suite à l'adoption de son bébé, Ava. Il est ravi de revenir mais aussi nerveux à l'idée de concilier travail et vie de famille. Vous avez programmé une réunion avec Dom pour l'accueillir et l'accompagner dans sa reprise de poste.",
      "keyDetails": [
        {
          "text": "Dom revient de plusieurs mois de congé parental"
        },
        {
          "text": "Il a récemment adopté un bébé nommé Ava"
        },
        {
          "text": "Dom est enthousiaste mais nerveux quant à son retour"
        },
        {
          "text": "Il a besoin de mises à jour sur l'évolution du travail, par exemple, il reprendra un nouveau projet géré par son remplaçant de congé parental"
        },
        {
          "text": "Dom a des inquiétudes concernant l'équilibre entre ses responsabilités professionnelles et familiales ; il aimerait faire davantage de télétravail"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Accueillir Dom chaleureusement et prendre des nouvelles de sa famille"
        },
        {
          "text": "Fournir les mises à jour clés à Dom et organiser une réunion avec son remplaçant de congé parental"
        },
        {
          "text": "Discuter des aménagements dont Dom pourrait avoir besoin, y compris la possibilité d'augmenter le temps de télétravail"
        },
        {
          "text": "Aborder les préoccupations de Dom concernant l'équilibre vie professionnelle-vie privée, y compris le manque de sommeil"
        },
        {
          "text": "Établir un plan pour augmenter progressivement la charge de travail de Dom et planifier des points de suivi réguliers"
        }
      ],
      "objectives": [
        {
          "text": "Assurer une transition fluide et bienveillante pour Dom lors de son retour au travail après son congé parental"
        },
        {
          "text": "Répondre aux préoccupations de Dom et favoriser sa réussite dans l'équilibre entre travail et famille\n"
        }
      ]
    }
  },
  {
    "scenarioId": 17,
    "language": "fr-FR",
    "translations": {
      "context": "Rose, une collaboratrice directe, a récemment reçu un diagnostic de TDAH. Elle a partagé le diagnostic avec vous par e-mail, mais a demandé un entretien pour discuter des détails, plus précisément de la façon dont vous pouvez l'aider à adapter son poste à ses besoins. ",
      "keyDetails": [
        {
          "text": "Rose a récemment reçu un diagnostic de TDAH"
        },
        {
          "text": "Elle souhaite discuter des aménagements pour ses besoins professionnels"
        },
        {
          "text": "Rose souhaite tirer parti de ses forces liées au TDAH"
        },
        {
          "text": "Vous devez faire preuve de soutien et de compréhension"
        },
        {
          "text": "L'objectif est de créer un plan d'action qui profite à la fois à Rose et à l'organisation"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Accueillir Rose et exprimer votre soutien pour avoir partagé cette information"
        },
        {
          "text": "Écouter le point de vue de Rose sur son diagnostic et son impact sur son travail"
        },
        {
          "text": "Discuter des aménagements potentiels dont Rose pourrait avoir besoin"
        },
        {
          "text": "Explorer les forces de Rose liées au TDAH et comment les valoriser"
        },
        {
          "text": "Développer en collaboration un plan d'action pour mettre en œuvre les changements afin de la soutenir"
        }
      ],
      "objectives": [
        {
          "text": "Assurer une discussion bienveillante et productive concernant le diagnostic de TDAH de Rose"
        },
        {
          "text": "Discuter en collaboration d'idées d'aménagements et de la valorisation des forces de Rose"
        }
      ]
    }
  },
  {
    "scenarioId": 20,
    "language": "fr-FR",
    "translations": {
      "context": "Morgan, une bonne employée de votre équipe, n'a pas obtenu la promotion interne pour laquelle elle avait postulé. Elle n'était pas tout à fait prête pour cette étape, mais elle est appréciée par l'entreprise et possède un potentiel d'avancement futur. Vous avez prévu cette réunion pour lui annoncer la nouvelle.",
      "keyDetails": [
        {
          "text": "Morgan n'a pas obtenu la promotion pour laquelle elle a postulé"
        },
        {
          "text": "C'est une bonne employée avec un potentiel d'évolution future"
        },
        {
          "text": "Vous devez maintenir sa motivation malgré la déception"
        },
        {
          "text": "Fournir un feedback constructif sur les axes d'amélioration (ex : améliorer ses compétences en communication écrite dans ses e-mails aux clients)"
        },
        {
          "text": "Tracer un parcours pour sa croissance et son développement futurs"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Entamer la conversation avec empathie et reconnaître les efforts de Morgan"
        },
        {
          "text": "Communiquer clairement la décision concernant la promotion"
        },
        {
          "text": "Fournir un feedback spécifique sur les axes d'amélioration (ex : améliorer les compétences en communication écrite dans ses e-mails aux clients)"
        },
        {
          "text": "Discuter de la valeur de Morgan pour l'entreprise et de son potentiel futur"
        },
        {
          "text": "Élaborer en collaboration un plan de croissance et de développement futurs"
        }
      ],
      "objectives": [
        {
          "text": "Communiquer l'échec de la demande de promotion tout en maintenant une atmosphère positive"
        },
        {
          "text": "Fournir un feedback constructif et élaborer un plan pour la croissance future de Morgan"
        }
      ]
    }
  },
  {
    "scenarioId": 21,
    "language": "fr-FR",
    "translations": {
      "context": "Ollie, membre de votre équipe, ne recevra pas de prime cette année en raison de ses performances satisfaisantes (mais pas exceptionnelles) et du manque de croissance de l'entreprise dans une économie difficile. \n\nVous avez organisé une réunion avec Ollie pour lui faire part de la nouvelle. Ollie sait que la réunion porte sur la décision concernant sa prime, mais il n'a pas été informé du résultat à l'avance. ",
      "keyDetails": [
        {
          "text": "Ollie ne recevra pas de prime cette année"
        },
        {
          "text": "Ses performances étaient satisfaisantes mais pas exceptionnelles"
        },
        {
          "text": "Le manque de croissance de l'entreprise est également un facteur"
        },
        {
          "text": "Vous devez gérer la déception ou la colère potentielle"
        },
        {
          "text": "Expliquez-lui qu'il doit assumer davantage de responsabilités pour augmenter ses chances d'obtenir une prime l'année prochaine"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Entamer la conversation et annoncer la nouvelle de manière claire et empathique"
        },
        {
          "text": "Expliquer les raisons de la décision (performances individuelles et de l'entreprise)"
        },
        {
          "text": "Écouter et prendre en compte la réaction d'Ollie"
        },
        {
          "text": "Discuter des domaines spécifiques d'amélioration des performances, tels que la prise de responsabilités accrues"
        },
        {
          "text": "Définir les attentes pour l'obtention d'une prime l'année prochaine"
        }
      ],
      "objectives": [
        {
          "text": "Annoncer la nouvelle de l'absence de prime avec empathie"
        },
        {
          "text": "Planifier une réunion de suivi pour élaborer un plan d'amélioration détaillé"
        }
      ]
    }
  },
  {
    "scenarioId": 22,
    "language": "fr-FR",
    "translations": {
      "context": "Hannah, une membre de votre équipe, est aux prises avec sa charge de travail et se sent dépassée. Elle vous a envoyé un e-mail demandant un entretien pour discuter de la situation.",
      "keyDetails": [
        {
          "text": "Hannah est aux prises avec sa charge de travail et se sent dépassée"
        },
        {
          "text": "Elle éprouve des difficultés à prioriser ses tâches"
        },
        {
          "text": "Hannah a le sentiment de ne rien accomplir en conséquence"
        },
        {
          "text": "Elle a peur de décevoir l'équipe"
        },
        {
          "text": "L'objectif est de la soutenir dans la gestion de sa charge de travail et de réduire son stress        \n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Engagez la conversation avec empathie et reconnaissez les préoccupations de Hannah"
        },
        {
          "text": "Écoutez le point de vue de Hannah sur les défis liés à sa charge de travail"
        },
        {
          "text": "Aidez Hannah à prioriser ses tâches"
        },
        {
          "text": "Discutez de stratégies pour une meilleure gestion du temps et une réduction du stress, comme l'activation du mode Ne pas déranger et le blocage de créneaux dans son calendrier pour les tâches importantes"
        },
        {
          "text": "Proposez du soutien et des ressources pour l'aider à gérer sa charge de travail\n"
        }
      ],
      "objectives": [
        {
          "text": "Écouter les préoccupations de Hannah et la soutenir dans la gestion de sa charge de travail"
        },
        {
          "text": "Élaborer un plan pour aider Hannah à gérer son stress et améliorer sa productivité"
        }
      ]
    }
  },
  {
    "scenarioId": 23,
    "language": "fr-FR",
    "translations": {
      "context": "Sarah, une membre de votre équipe, semble beaucoup moins engagée qu'elle ne l'était auparavant. Bien qu'elle termine toujours les tâches assignées à temps, son travail semble souvent se limiter au strict minimum. Elle montre peu d'enthousiasme pour son rôle et s'engage rarement au-delà de ses responsabilités de base, alors qu'auparavant, elle était la personne de votre équipe qui se surpassait toujours. \n\nVous avez planifié une réunion avec Sarah pour comprendre s'il y a quelque chose qui motive ce changement et voir si vous pouvez l'aider. Sarah ne sait pas quel est l'objet de la réunion. ",
      "keyDetails": [
        {
          "text": "Sarah termine ses tâches à temps mais fait preuve d'un effort minimal\n"
        },
        {
          "text": "Elle s'engage rarement au-delà de ses responsabilités de base\n"
        },
        {
          "text": "Elle semble déconnectée de la mission de l'organisation\n"
        },
        {
          "text": "Elle a cessé d'assister aux réunions facultatives ou aux événements sociaux professionnels"
        },
        {
          "text": "Vous aimeriez trouver des moyens de redynamiser son enthousiasme  "
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objet de la réunion"
        },
        {
          "text": "Interroger Sarah sur ses sentiments actuels à l'égard de son travail et de l'organisation"
        },
        {
          "text": "Écouter le point de vue de Sarah sur sa baisse d'engagement"
        },
        {
          "text": "Discuter de l'impact de l'engagement sur la dynamique et le succès de l'équipe"
        },
        {
          "text": "Explorer ensemble des stratégies pour raviver l'enthousiasme de Sarah"
        }
      ],
      "objectives": [
        {
          "text": "Traiter le problème du faible engagement tout en maintenant une atmosphère de soutien et de motivation"
        },
        {
          "text": "Discuter ensemble d'idées pour renforcer l'engagement et l'enthousiasme de Sarah"
        }
      ]
    }
  },
  {
    "scenarioId": 24,
    "language": "fr-FR",
    "translations": {
      "context": "Nina, l'une de vos collaboratrices directes, vient de perdre sa grand-mère et vous a envoyé un message pour discuter de la prise de congés. Cela se produit pendant une période particulièrement chargée pour l'équipe, ce qui rend difficile l'absence d'un membre de l'équipe. Vous avez programmé une réunion avec Nina pour discuter de la situation.",
      "keyDetails": [
        {
          "text": "Nina a perdu sa grand-mère\n"
        },
        {
          "text": "Elle a besoin de congés pour deuil\n"
        },
        {
          "text": "C'est une période chargée pour l'équipe\n"
        },
        {
          "text": "Vous devez équilibrer le soutien et les besoins du service"
        },
        {
          "text": "Vous devez déterminer un plan pour le congé de Nina et la couverture des tâches        "
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Présenter ses condoléances et sa sympathie pour la perte de Nina\n"
        },
        {
          "text": "Écouter les besoins de Nina concernant ses congés\n"
        },
        {
          "text": "Discuter de la situation actuelle du travail et des priorités\n"
        },
        {
          "text": "Élaborer ensemble un plan pour les congés et la couverture des tâches\n"
        },
        {
          "text": "Offrir du soutien et des ressources pour le retour de Nina"
        }
      ],
      "objectives": [
        {
          "text": "Apporter soutien et sympathie à Nina pendant son deuil\n"
        },
        {
          "text": "Établir un plan pour le congé de Nina et gérer les responsabilités professionnelles        "
        }
      ]
    }
  },
  {
    "scenarioId": 25,
    "language": "fr-FR",
    "translations": {
      "context": "Nick est l'un de vos subordonnés directs. Lors des récents comptes rendus d'entretiens pour un nouveau recrutement, vous avez remarqué que les commentaires de Nick à l'égard des candidates étaient nettement plus sévères que pour les candidats masculins. \n\nVous avez planifié cette réunion avec lui pour discuter de ce que vous considérez comme un biais inconscient. Nick sait que la réunion porte sur les entretiens, mais il ne sait pas que vous allez aborder ce point spécifique.",
      "keyDetails": [
        {
          "text": "Nick a fait preuve de partialité envers les candidates lors des récents entretiens"
        },
        {
          "text": "Ses notes et ses commentaires étaient plus sévères pour les femmes que pour les candidats masculins"
        },
        {
          "text": "Il a fait des commentaires inacceptables lors des comptes rendus d'entretiens"
        },
        {
          "text": "Par exemple, il a fait remarquer que les candidates disparaîtraient bientôt pour avoir des enfants"
        },
        {
          "text": "Vous voulez que Nick comprenne ses biais tout en maintenant une atmosphère constructive"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Ouvrir la conversation et expliquer l'objectif de la réunion"
        },
        {
          "text": "Fournir des exemples précis de comportements biaisés observés"
        },
        {
          "text": "Expliquer le concept de biais inconscient et son impact"
        },
        {
          "text": "Discuter de l'importance de la diversité et de l'inclusion dans le recrutement"
        },
        {
          "text": "Élaborer ensemble des stratégies pour une évaluation équitable"
        }
      ],
      "objectives": [
        {
          "text": "Aborder le biais inconscient de Nick dans le processus de recrutement et promouvoir des pratiques de recrutement inclusives"
        },
        {
          "text": "Maintenir une atmosphère constructive et pédagogique"
        }
      ]
    }
  },
  {
    "scenarioId": 43,
    "language": "fr-FR",
    "translations": {
      "context": "Un membre habituellement fiable de votre équipe, Jay, s'est montré visiblement irritable lors des récentes réunions d'équipe, affichant un comportement inhabituel qui a créé une certaine tension. En tant que son manager, vous avez programmé un entretien privé après avoir observé ces changements et reçu des préoccupations informelles d'autres membres de l'équipe.",
      "keyDetails": [
        {
          "text": "Jay est performant mais s'est montré visiblement irritable ces dernières semaines"
        },
        {
          "text": "Vous avez remarqué ce changement à plusieurs reprises (par exemple, la semaine dernière, il a été irritable envers quelqu'un de l'équipe à qui on posait une question normale sur l'état de son projet)"
        },
        {
          "text": "Vous êtes très préoccupé car cela ne lui ressemble pas et vous voulez vérifier s'il va bien"
        },
        {
          "text": "Votre rôle est d'écouter et de soutenir, pas de sanctionner"
        },
        {
          "text": "Votre objectif est de créer un espace de confiance afin que Jay se sente à l'aise pour s'ouvrir"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Commencez par des questions générales sur le bien-être et instaurez une sécurité psychologique avant d'évoquer des comportements spécifiques"
        },
        {
          "text": "Partagez vos observations sur les changements de comportement dans une démarche de bienveillance et non de critique"
        },
        {
          "text": "Écoutez activement et laissez des silences - donnez à Jay l'espace nécessaire pour s'ouvrir naturellement"
        },
        {
          "text": "Si Jay partage des difficultés personnelles, concentrez-vous d'abord sur la compréhension avant de passer aux solutions"
        },
        {
          "text": "Terminez par des prochaines étapes claires et convenues mutuellement, tout en soulignant votre soutien continu et votre disponibilité"
        }
      ],
      "objectives": [
        {
          "text": "Créer un espace sûr et confidentiel permettant à Jay de partager tout problème sous-jacent affectant son comportement au travail"
        },
        {
          "text": "Offrir du soutien à Jay et convenir avec lui de la manière dont vous pouvez l'aider"
        }
      ]
    }
  },
  {
    "scenarioId": 1,
    "language": "de-DE",
    "translations": {
      "context": "Joe, ein direkter Mitarbeiter in Ihrem Team, hat Projektfristen wiederholt nicht eingehalten. Dies wirkt sich auf die allgemeine Teamleistung und die Projektzeitpläne aus.  \n\nSie haben ein Treffen mit Joe vereinbart, um die verpassten Fristen zu besprechen.",
      "keyDetails": [
        {
          "text": "Joe hat mehrere aktuelle Fristen verpasst"
        },
        {
          "text": "Zum Beispiel: Er hat seinen letzten Bericht eine Woche zu spät fertiggestellt und kürzlich zwei Tage zu spät Beiträge zu einer Präsentation eines Teammitglieds geliefert"
        },
        {
          "text": "Das Problem beeinträchtigt die Teamleistung und die Zeitpläne"
        },
        {
          "text": "Joe war in der Vergangenheit ein guter Leistungsträger"
        },
        {
          "text": "Ziel ist es, Joe zu helfen, sich zu verbessern, nicht ihn zu bestrafen"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Treffens erläutern"
        },
        {
          "text": "Spezifische Beispiele für verpasste Fristen und deren Auswirkungen nennen"
        },
        {
          "text": "Joes Perspektive und eventuelle Herausforderungen anhören"
        },
        {
          "text": "Gemeinsam nächste Schritte erarbeiten, um Joe zu helfen, sich zu verbessern, z.B. Joe bei der Priorisierung seiner Projekte unterstützen"
        },
        {
          "text": "Klare Erwartungen und Folgeschritte festlegen"
        }
      ],
      "objectives": [
        {
          "text": "Joes Leistungsproblem ansprechen, während eine positive Arbeitsbeziehung aufrechterhalten wird"
        },
        {
          "text": "Gemeinsam nächste Schritte vereinbaren, um Joe bei der Verbesserung seines Zeitmanagements zu helfen"
        }
      ]
    }
  },
  {
    "scenarioId": 1,
    "language": "es-US",
    "translations": {
      "context": "Joe, un colaborador directo de tu equipo, ha estado incumpliendo constantemente los plazos de los proyectos. Esto está afectando el rendimiento general del equipo y los cronogramas del proyecto. \n\nHas programado una reunión con Joe para discutir los plazos incumplidos.",
      "keyDetails": [
        {
          "text": "Joe ha incumplido varios plazos recientes"
        },
        {
          "text": "Por ejemplo: terminó su último informe una semana tarde y recientemente aportó a la presentación de un miembro del equipo con dos días de retraso"
        },
        {
          "text": "El problema está afectando el rendimiento del equipo y los cronogramas"
        },
        {
          "text": "Joe ha tenido un buen desempeño en el pasado"
        },
        {
          "text": "El objetivo es ayudar a Joe a mejorar, no castigar"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Proporcionar ejemplos específicos de plazos incumplidos y su impacto"
        },
        {
          "text": "Escuchar la perspectiva de Joe y cualquier desafío que esté enfrentando"
        },
        {
          "text": "Colaborar en los próximos pasos para ayudar a Joe a mejorar, por ejemplo, ayudándolo con la priorización de sus proyectos"
        },
        {
          "text": "Establecer expectativas claras y pasos de seguimiento"
        }
      ],
      "objectives": [
        {
          "text": "Abordar el problema de rendimiento de Joe mientras se mantiene una relación laboral positiva"
        },
        {
          "text": "Acordar colaborativamente los próximos pasos para ayudar a Joe a mejorar su gestión del tiempo"
        }
      ]
    }
  },
  {
    "scenarioId": 10,
    "language": "cmn-CN",
    "translations": {
      "context": "一项新的混合工作政策要求员工每周至少到办公室两次。你的下属Alex一直完全远程工作，没有遵守这项政策。你已经通过电子邮件向Alex提出了这个问题，并安排了一次会议与Alex讨论情况。",
      "keyDetails": [
        {
          "text": "新政策要求每周到办公室两次"
        },
        {
          "text": "Alex一直完全远程工作"
        },
        {
          "text": "Alex没有遵守新政策"
        },
        {
          "text": "你需要确保Alex开始每周到办公室两次"
        },
        {
          "text": "在执行政策的同时保持支持性的态度"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开启对话并解释会议目的"
        },
        {
          "text": "清晰地传达混合工作政策"
        },
        {
          "text": "倾听Alex不来办公室的原因"
        },
        {
          "text": "解决疑虑并讨论面对面协作的好处"
        },
        {
          "text": "共同制定办公室出勤计划        \n"
        }
      ],
      "objectives": [
        {
          "text": "处理不遵守政策的问题，同时保持积极的工作关系"
        },
        {
          "text": "与Alex达成共识，她需要开始每周到办公室两天"
        }
      ]
    }
  },
  {
    "scenarioId": 10,
    "language": "de-DE",
    "translations": {
      "context": "Eine neue Hybrid-Arbeitsrichtlinie verlangt von den Mitarbeitern, mindestens zweimal pro Woche im Büro zu sein. Alex, einer Ihrer direkten Mitarbeiter, hat ausschließlich remote gearbeitet und die Richtlinie nicht eingehalten. Sie haben dies Alex per E-Mail mitgeteilt und ein Treffen mit Alex vereinbart, um die Situation zu besprechen.",
      "keyDetails": [
        {
          "text": "Neue Richtlinie erfordert zweimal wöchentliche Präsenz im Büro"
        },
        {
          "text": "Alex hat ausschließlich remote gearbeitet"
        },
        {
          "text": "Alex hat die neue Richtlinie nicht eingehalten"
        },
        {
          "text": "Sie müssen sicherstellen, dass Alex zweimal pro Woche ins Büro kommt"
        },
        {
          "text": "Einen unterstützenden Ansatz beibehalten, während die Richtlinie durchgesetzt wird"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Treffens erläutern"
        },
        {
          "text": "Die Hybrid-Arbeitsrichtlinie klar kommunizieren"
        },
        {
          "text": "Alex' Gründe für das Nicht-Erscheinen im Büro anhören"
        },
        {
          "text": "Bedenken ansprechen und Vorteile der persönlichen Zusammenarbeit besprechen"
        },
        {
          "text": "Gemeinsam einen Plan für die Büropräsenz entwickeln        \n"
        }
      ],
      "objectives": [
        {
          "text": "Die Nichteinhaltung der Richtlinie ansprechen und gleichzeitig eine positive Arbeitsbeziehung aufrechterhalten"
        },
        {
          "text": "Mit Alex abstimmen, dass sie an zwei Tagen pro Woche ins Büro kommen muss"
        }
      ]
    }
  },
  {
    "scenarioId": 10,
    "language": "es-US",
    "translations": {
      "context": "Una nueva política de trabajo híbrido requiere que los empleados estén en la oficina al menos dos veces por semana. Alex, uno de tus colaboradores directos, ha estado trabajando completamente de forma remota y no ha cumplido con la política. Ya lo has planteado con Alex por correo electrónico y has programado una reunión con Alex para discutir la situación.",
      "keyDetails": [
        {
          "text": "La nueva política requiere presencia en la oficina dos veces por semana"
        },
        {
          "text": "Alex ha estado trabajando completamente de forma remota"
        },
        {
          "text": "Alex no ha cumplido con la nueva política"
        },
        {
          "text": "Debes asegurarte de que Alex empiece a venir a la oficina dos veces por semana"
        },
        {
          "text": "Mantener un enfoque de apoyo mientras se aplica la política"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Comunicar claramente la política de trabajo híbrido"
        },
        {
          "text": "Escuchar las razones de Alex para no venir a la oficina"
        },
        {
          "text": "Abordar las preocupaciones y discutir los beneficios de la colaboración en persona"
        },
        {
          "text": "Desarrollar colaborativamente un plan para la asistencia a la oficina        \n"
        }
      ],
      "objectives": [
        {
          "text": "Abordar el incumplimiento de la política manteniendo una relación de trabajo positiva"
        },
        {
          "text": "Acordar con Alex que necesita empezar a venir a la oficina dos días a la semana"
        }
      ]
    }
  },
  {
    "scenarioId": 11,
    "language": "cmn-CN",
    "translations": {
      "context": "Jim，你团队中一名表现出色的员工，因裁员而被解雇，立即生效。此决定并非基于他的绩效。你已安排此次谈话，以告知他被裁员的消息。",
      "keyDetails": [
        {
          "text": "Jim 因裁员而被解雇"
        },
        {
          "text": "该决定立即生效"
        },
        {
          "text": "Jim 是一名表现出色的员工，该决定与绩效无关"
        },
        {
          "text": "裁员补偿方案是一个月的全薪"
        },
        {
          "text": "你需要在处理自己情绪的同时保持专业性"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始谈话并清晰地告知裁员消息"
        },
        {
          "text": "解释该决定是由于裁员，而非绩效原因"
        },
        {
          "text": "提供有关裁员补偿方案的详细信息"
        },
        {
          "text": "对 Jim 的贡献表示感谢"
        },
        {
          "text": "回答 Jim 可能提出的任何即时问题或疑虑"
        }
      ],
      "objectives": [
        {
          "text": "清晰专业地传达裁员决定"
        },
        {
          "text": "在传达困难消息的同时，对 Jim 的贡献表示感谢"
        }
      ]
    }
  },
  {
    "scenarioId": 11,
    "language": "de-DE",
    "translations": {
      "context": "Jim, ein leistungsstarker Mitarbeiter in Ihrem Team, wird aufgrund von Personalabbau mit sofortiger Wirkung entlassen. Diese Entscheidung basierte nicht auf seiner Leistung. Sie haben dieses Gespräch angesetzt, um ihn über seine Entlassung zu informieren.",
      "keyDetails": [
        {
          "text": "Jim wird aufgrund von Personalabbau entlassen"
        },
        {
          "text": "Die Entscheidung ist mit sofortiger Wirkung"
        },
        {
          "text": "Jim ist ein leistungsstarker Mitarbeiter, die Entscheidung ist nicht leistungsbezogen"
        },
        {
          "text": "Das Abfindungspaket umfasst ein volles Monatsgehalt"
        },
        {
          "text": "Sie müssen Professionalität bewahren, während Sie mit Ihren eigenen Emotionen umgehen"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Eröffnen Sie das Gespräch und überbringen Sie die Nachricht der Entlassung klar und deutlich"
        },
        {
          "text": "Erklären Sie, dass die Entscheidung auf Personalabbau und nicht auf Leistung zurückzuführen ist"
        },
        {
          "text": "Geben Sie Details zum Abfindungspaket an"
        },
        {
          "text": "Drücken Sie Ihre Wertschätzung für Jims Beiträge aus"
        },
        {
          "text": "Beantworten Sie alle unmittelbaren Fragen oder Bedenken, die Jim haben könnte"
        }
      ],
      "objectives": [
        {
          "text": "Die Entlassungsentscheidung klar und professionell kommunizieren"
        },
        {
          "text": "Wertschätzung für Jims Beiträge ausdrücken, während die schwierige Nachricht überbracht wird"
        }
      ]
    }
  },
  {
    "scenarioId": 11,
    "language": "es-US",
    "translations": {
      "context": "Jim, un empleado de alto rendimiento en tu equipo, será desvinculado debido a recortes de personal, con efecto inmediato. Esta decisión no se basó en su desempeño. Has programado esta conversación para informarle sobre su desvinculación.",
      "keyDetails": [
        {
          "text": "Jim será desvinculado debido a recortes de personal"
        },
        {
          "text": "La decisión es efectiva de inmediato"
        },
        {
          "text": "Jim es un empleado de alto rendimiento, la decisión no está relacionada con su desempeño"
        },
        {
          "text": "El paquete de desvinculación es un mes de salario completo"
        },
        {
          "text": "Debes mantener el profesionalismo mientras manejas tus propias emociones"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y comunicar claramente la noticia de la desvinculación"
        },
        {
          "text": "Explicar que la decisión se debe a recortes de personal, no al desempeño"
        },
        {
          "text": "Proporcionar detalles sobre el paquete de desvinculación"
        },
        {
          "text": "Expresar agradecimiento por las contribuciones de Jim"
        },
        {
          "text": "Abordar cualquier pregunta o inquietud inmediata que Jim pueda tener"
        }
      ],
      "objectives": [
        {
          "text": "Comunicar la decisión de desvinculación de manera clara y profesional"
        },
        {
          "text": "Expresar agradecimiento por las contribuciones de Jim mientras se comunica la difícil noticia"
        }
      ]
    }
  },
  {
    "scenarioId": 12,
    "language": "cmn-CN",
    "translations": {
      "context": "Joe，您的直接下属，因持续表现不佳将被解雇，即刻生效。您之前已与Joe就其表现进行过多次谈话，但未见改善，因此决定终止其雇佣关系。您已安排会议告知Joe此消息。",
      "keyDetails": [
        {
          "text": "Joe因持续表现不佳将被解雇"
        },
        {
          "text": "该决定即刻生效"
        },
        {
          "text": "您之前已与Joe就其表现进行过多次谈话，但未见改善"
        },
        {
          "text": "Joe的工资将支付至本月底"
        },
        {
          "text": "在整个艰难的谈话过程中保持专业性"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始谈话并清晰地告知消息\n"
        },
        {
          "text": "解释该决定是由于持续的绩效问题"
        },
        {
          "text": "提及之前的绩效谈话"
        },
        {
          "text": "提供关于遣散费和后续步骤的详细信息"
        },
        {
          "text": "解答Joe可能有的任何即时问题或疑虑"
        }
      ],
      "objectives": [
        {
          "text": "清晰且专业地传达解雇决定"
        },
        {
          "text": "提供关于遣散费和后续步骤的必要信息"
        }
      ]
    }
  },
  {
    "scenarioId": 12,
    "language": "de-DE",
    "translations": {
      "context": "Joe, ein direkter Mitarbeiter, wird aufgrund anhaltend schlechter Leistung mit sofortiger Wirkung gekündigt. Sie hatten bereits mehrere Gespräche mit Joe über seine Leistung, aber es gab keine Verbesserung, daher die Entscheidung, sein Arbeitsverhältnis zu beenden. Sie haben ein Treffen vereinbart, um Joe über diese Neuigkeiten zu informieren.",
      "keyDetails": [
        {
          "text": "Joe wird aufgrund anhaltend schlechter Leistung gekündigt"
        },
        {
          "text": "Die Entscheidung ist mit sofortiger Wirkung"
        },
        {
          "text": "Sie hatten bereits mehrere Leistungsgespräche mit Joe, aber es gab keine Verbesserung"
        },
        {
          "text": "Joe wird bis zum Monatsende bezahlt"
        },
        {
          "text": "Wahren Sie Professionalität während des schwierigen Gesprächs"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Eröffnen Sie das Gespräch und überbringen Sie die Nachricht klar und deutlich\n"
        },
        {
          "text": "Erläutern Sie, dass die Entscheidung auf anhaltende Leistungsprobleme zurückzuführen ist"
        },
        {
          "text": "Beziehen Sie sich auf frühere Leistungsgespräche"
        },
        {
          "text": "Geben Sie Details zum Abfindungspaket und den nächsten Schritten"
        },
        {
          "text": "Beantworten Sie alle unmittelbaren Fragen oder Bedenken, die Joe haben könnte"
        }
      ],
      "objectives": [
        {
          "text": "Die Kündigungsentscheidung klar und professionell kommunizieren"
        },
        {
          "text": "Notwendige Informationen zu Abfindung und nächsten Schritten bereitstellen"
        }
      ]
    }
  },
  {
    "scenarioId": 12,
    "language": "es-US",
    "translations": {
      "context": "Joe, un subalterno directo, será desvinculado debido a un rendimiento deficiente persistente, con efecto inmediato. Has tenido varias conversaciones previas con Joe sobre su rendimiento, pero no ha habido ninguna mejora, de ahí la decisión de terminar su empleo. Has programado una reunión para informarle a Joe de la noticia.",
      "keyDetails": [
        {
          "text": "Joe será desvinculado debido a un rendimiento deficiente persistente"
        },
        {
          "text": "La decisión es efectiva de inmediato"
        },
        {
          "text": "Has tenido múltiples conversaciones de rendimiento con Joe anteriormente, pero no ha habido ninguna mejora"
        },
        {
          "text": "A Joe se le pagará hasta fin de mes"
        },
        {
          "text": "Mantén el profesionalismo durante toda la conversación difícil"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Inicia la conversación y comunica la noticia claramente\n"
        },
        {
          "text": "Explica que la decisión se debe a problemas de rendimiento persistentes"
        },
        {
          "text": "Haz referencia a conversaciones de rendimiento anteriores"
        },
        {
          "text": "Proporciona detalles sobre el paquete de indemnización y los próximos pasos"
        },
        {
          "text": "Aborda cualquier pregunta o inquietud inmediata que Joe pueda tener"
        }
      ],
      "objectives": [
        {
          "text": "Comunicar la decisión de desvinculación de manera clara y profesional"
        },
        {
          "text": "Proporcionar la información necesaria sobre la indemnización y los próximos pasos"
        }
      ]
    }
  },
  {
    "scenarioId": 13,
    "language": "cmn-CN",
    "translations": {
      "context": "Jordan，你团队的一名员工，在最近一次公司聚会上喝得酩酊大醉，行为不当，不得不被叫出租车送回家。你已经安排了与 Jordan 的会议来处理此事。",
      "keyDetails": [
        {
          "text": "Jordan 在最近一次公司聚会上喝得酩酊大醉，行为不当。"
        },
        {
          "text": "他对酒吧工作人员态度恶劣，你不得不叫出租车送他回家。"
        },
        {
          "text": "Jordan 正在经历离婚，这可能对他产生了影响。"
        },
        {
          "text": "你需要明确指出这种行为是不可接受的。"
        },
        {
          "text": "考虑到 Jordan 的个人情况，在坚定立场的同时要保持同理心。"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并解释会议目的。"
        },
        {
          "text": "描述 Jordan 在聚会上的行为及其影响。"
        },
        {
          "text": "倾听 Jordan 的看法以及他可能面临的个人问题。"
        },
        {
          "text": "明确传达对未来行为的期望。"
        },
        {
          "text": "在强调事件严重性的同时，提供必要的支持。"
        }
      ],
      "objectives": [
        {
          "text": "处理 Jordan 的不当行为。"
        },
        {
          "text": "在表达同理心的同时，为未来的行为设定明确的期望。"
        }
      ]
    }
  },
  {
    "scenarioId": 13,
    "language": "de-DE",
    "translations": {
      "context": "Jordan, ein Mitarbeiter in Ihrem Team, hat sich auf einer kürzlichen Firmenfeier extrem betrunken, unangemessen verhalten und musste mit einem Taxi nach Hause geschickt werden. Sie haben ein Treffen mit Jordan vereinbart, um die Situation zu besprechen.",
      "keyDetails": [
        {
          "text": "Jordan hat sich auf einer kürzlichen Firmenfeier extrem betrunken und sein Verhalten war unangemessen."
        },
        {
          "text": "Er war dem Barpersonal gegenüber unangenehm und Sie mussten ihn mit einem Taxi nach Hause schicken."
        },
        {
          "text": "Jordan durchläuft eine Scheidung, was ihn möglicherweise beeinflusst."
        },
        {
          "text": "Sie müssen deutlich machen, dass dieses Verhalten inakzeptabel ist."
        },
        {
          "text": "Finden Sie ein Gleichgewicht zwischen Entschlossenheit und Empathie angesichts Jordans persönlicher Umstände."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Eröffnen Sie das Gespräch und erläutern Sie den Zweck des Treffens."
        },
        {
          "text": "Beschreiben Sie Jordans Verhalten auf der Feier und dessen Auswirkungen."
        },
        {
          "text": "Hören Sie Jordans Perspektive und eventuellen persönlichen Problemen zu, mit denen er konfrontiert ist."
        },
        {
          "text": "Kommunizieren Sie klar die Erwartungen an zukünftiges Verhalten."
        },
        {
          "text": "Bieten Sie bei Bedarf Unterstützung an, während Sie die Ernsthaftigkeit der Situation betonen."
        }
      ],
      "objectives": [
        {
          "text": "Jordans unangemessenes Verhalten ansprechen."
        },
        {
          "text": "Klare Erwartungen für zukünftiges Verhalten festlegen und gleichzeitig Empathie zeigen."
        }
      ]
    }
  },
  {
    "scenarioId": 13,
    "language": "es-US",
    "translations": {
      "context": "Jordan, un empleado de su equipo, se emborrachó muchísimo en una fiesta de trabajo reciente, se comportó de manera inapropiada y tuvo que ser enviado a casa en un taxi. Usted ha programado una reunión con Jordan para abordar la situación.",
      "keyDetails": [
        {
          "text": "Jordan se emborrachó muchísimo en una fiesta de trabajo reciente y su comportamiento fue inapropiado."
        },
        {
          "text": "Fue desagradable con el personal del bar y usted tuvo que enviarlo a casa en un taxi."
        },
        {
          "text": "Jordan está pasando por un divorcio, lo cual podría estar afectándolo."
        },
        {
          "text": "Debe dejar claro que este comportamiento es inaceptable."
        },
        {
          "text": "Equilibre la firmeza con la empatía dadas las circunstancias personales de Jordan."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abra la conversación y explique el propósito de la reunión."
        },
        {
          "text": "Describa el comportamiento de Jordan en la fiesta y su impacto."
        },
        {
          "text": "Escuche la perspectiva de Jordan y cualquier problema personal que esté enfrentando."
        },
        {
          "text": "Comunique claramente las expectativas para el comportamiento futuro."
        },
        {
          "text": "Ofrezca apoyo si es necesario, mientras refuerza la seriedad de la situación."
        }
      ],
      "objectives": [
        {
          "text": "Abordar el comportamiento inapropiado de Jordan."
        },
        {
          "text": "Establecer expectativas claras para la conducta futura, mostrando empatía."
        }
      ]
    }
  },
  {
    "scenarioId": 14,
    "language": "cmn-CN",
    "translations": {
      "context": "团队成员Joe多次迟到，未能按时参加各种工作安排，包括视频会议、办公室工作日和客户会议。虽然迟到通常只有几分钟，但这些延误正在对公司形象造成负面影响，并浪费他人的时间。\n\n你已经安排了与Joe的会议来讨论这个问题，并提前告知他会议内容是关于他的准时性。",
      "keyDetails": [
        {
          "text": "Joe一直未能按时参加工作安排"
        },
        {
          "text": "迟到时间从几分钟到10分钟不等"
        },
        {
          "text": "例如，他本周参加团队会议迟到10分钟；昨天参加客户会议迟到5分钟"
        },
        {
          "text": "他的迟到正在影响公司形象和他人的时间"
        },
        {
          "text": "你需要了解他迟到的原因"
        },
        {
          "text": "目标是提高Joe的准时性"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并说明会议目的"
        },
        {
          "text": "提供迟到的具体例子及其影响（例如让客户等待）"
        },
        {
          "text": "倾听Joe的看法和迟到的原因"
        },
        {
          "text": "讨论准时性的重要性"
        },
        {
          "text": "共同制定提高准时性的策略"
        }
      ],
      "objectives": [
        {
          "text": "解决Joe长期迟到的问题，同时保持积极的工作关系"
        },
        {
          "text": "制定提高Joe准时性的计划"
        }
      ]
    }
  },
  {
    "scenarioId": 14,
    "language": "de-DE",
    "translations": {
      "context": "Joe, ein Teammitglied, ist wiederholt zu verschiedenen Arbeitsverpflichtungen zu spät gekommen, darunter Videoanrufe, Bürotage und Kundentermine. Obwohl die Verzögerungen meist nur wenige Minuten betragen, wirken sie sich negativ auf das Unternehmensimage aus und verschwenden die Zeit anderer. \n\nSie haben ein Treffen mit Joe vereinbart, um die Situation zu besprechen, und ihn vorab informiert, dass es um seine Pünktlichkeit geht.",
      "keyDetails": [
        {
          "text": "Joe ist wiederholt zu Arbeitsverpflichtungen zu spät gekommen"
        },
        {
          "text": "Die Verspätungen reichen von wenigen Minuten bis zu 10 Minuten"
        },
        {
          "text": "Zum Beispiel kam er diese Woche 10 Minuten zu spät zum Teammeeting; gestern kam er 5 Minuten zu spät zu einem Kundentermin"
        },
        {
          "text": "Seine Unpünktlichkeit beeinträchtigt das Unternehmensimage und die Zeit anderer"
        },
        {
          "text": "Sie müssen die Gründe für seine Unpünktlichkeit verstehen"
        },
        {
          "text": "Das Ziel ist es, Joes Pünktlichkeit zu verbessern"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Treffens erläutern"
        },
        {
          "text": "Spezifische Beispiele für Unpünktlichkeit und deren Auswirkungen nennen (z. B. einen Kunden warten lassen)"
        },
        {
          "text": "Joes Perspektive und Gründe für die Unpünktlichkeit anhören"
        },
        {
          "text": "Die Bedeutung von Pünktlichkeit besprechen"
        },
        {
          "text": "Gemeinsam Strategien zur Verbesserung der Pünktlichkeit entwickeln"
        }
      ],
      "objectives": [
        {
          "text": "Joes chronische Unpünktlichkeit ansprechen und gleichzeitig eine positive Arbeitsbeziehung aufrechterhalten"
        },
        {
          "text": "Einen Plan zur Verbesserung von Joes Pünktlichkeit entwickeln"
        }
      ]
    }
  },
  {
    "scenarioId": 14,
    "language": "es-US",
    "translations": {
      "context": "Joe, un miembro del equipo, ha llegado tarde repetidamente a varios compromisos laborales, incluyendo videollamadas, días de oficina y reuniones con clientes. Aunque los retrasos suelen ser de solo unos minutos, están afectando negativamente la imagen de la empresa y haciendo perder el tiempo a otros. \n\nHas programado una reunión con Joe para discutir la situación y le has avisado que es sobre su puntualidad.",
      "keyDetails": [
        {
          "text": "Joe ha llegado tarde consistentemente a sus compromisos laborales"
        },
        {
          "text": "Los retrasos varían de unos pocos minutos a 10 minutos"
        },
        {
          "text": "Por ejemplo, se unió a la reunión de equipo 10 minutos tarde esta semana; se unió a una reunión con un cliente 5 minutos tarde ayer"
        },
        {
          "text": "Su impuntualidad está afectando la imagen de la empresa y el tiempo de otros"
        },
        {
          "text": "Necesitas entender las razones detrás de su impuntualidad"
        },
        {
          "text": "El objetivo es mejorar la puntualidad de Joe"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Proporcionar ejemplos específicos de impuntualidad y su impacto (ej. hacer esperar a un cliente)"
        },
        {
          "text": "Escuchar la perspectiva de Joe y las razones de su impuntualidad"
        },
        {
          "text": "Discutir la importancia de la puntualidad"
        },
        {
          "text": "Desarrollar colaborativamente estrategias para mejorar la puntualidad"
        }
      ],
      "objectives": [
        {
          "text": "Abordar la impuntualidad crónica de Joe manteniendo una relación laboral positiva"
        },
        {
          "text": "Desarrollar un plan para mejorar la puntualidad de Joe"
        }
      ]
    }
  },
  {
    "scenarioId": 15,
    "language": "cmn-CN",
    "translations": {
      "context": "Lucas是您团队中的一名远程员工，最近在工作时间经常离线且不回复消息，导致紧急请求无法及时处理。您已安排与Lucas会面以解决此问题。",
      "keyDetails": [
        {
          "text": "Lucas在工作时间经常离线且不回复消息"
        },
        {
          "text": "例如，上周您在当天会议前需要他的意见时，他没有回复。几天前，尽管他的日程表是空的，他一上午也没有回复。\n"
        },
        {
          "text": "您需要明确对在线状态的期望"
        },
        {
          "text": "了解Lucas对弹性工作的看法"
        },
        {
          "text": "在灵活性和响应速度之间找到平衡"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并说明会议目的"
        },
        {
          "text": "提供在线状态问题的具体示例及其影响"
        },
        {
          "text": "倾听Lucas对弹性工作的看法"
        },
        {
          "text": "讨论在核心工作时间保持可联系的重要性"
        },
        {
          "text": "共同制定改进在线状态的计划"
        }
      ],
      "objectives": [
        {
          "text": "解决Lucas的在线状态问题，并为远程工作的在线状态建立明确的期望"
        },
        {
          "text": "与Lucas就他如何改进远程工作时的沟通达成一致"
        }
      ]
    }
  },
  {
    "scenarioId": 15,
    "language": "de-DE",
    "translations": {
      "context": "Lucas, ein Remote-Mitarbeiter in Ihrem Team, war in letzter Zeit während der Arbeitszeiten offline und nicht erreichbar, was zu Problemen bei dringenden Anfragen führte. Sie haben ein Treffen mit Lucas vereinbart, um die Situation zu besprechen.",
      "keyDetails": [
        {
          "text": "Lucas war während der Arbeitszeiten offline und nicht erreichbar"
        },
        {
          "text": "Zum Beispiel hat er letzte Woche nicht geantwortet, als Sie seinen Input vor einem Meeting am selben Tag benötigten. Er hat auch vor ein paar Tagen den ganzen Vormittag nicht geantwortet, obwohl sein Kalender frei war.\n"
        },
        {
          "text": "Sie müssen die Erwartungen an die Erreichbarkeit klären"
        },
        {
          "text": "Lucas' Perspektive auf flexibles Arbeiten verstehen"
        },
        {
          "text": "Ein Gleichgewicht zwischen Flexibilität und Reaktionsfähigkeit finden"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Meetings erläutern"
        },
        {
          "text": "Spezifische Beispiele für Erreichbarkeitsprobleme und deren Auswirkungen nennen"
        },
        {
          "text": "Lucas' Perspektive auf flexibles Arbeiten anhören"
        },
        {
          "text": "Die Bedeutung der Erreichbarkeit während der Kernarbeitszeiten besprechen"
        },
        {
          "text": "Gemeinsam einen Plan zur Verbesserung der Erreichbarkeit entwickeln"
        }
      ],
      "objectives": [
        {
          "text": "Lucas' Erreichbarkeitsprobleme ansprechen und klare Erwartungen an die Erreichbarkeit bei Remote-Arbeit festlegen"
        },
        {
          "text": "Mit Lucas abstimmen, wie er seine Kommunikation bei Remote-Arbeit verbessern kann"
        }
      ]
    }
  },
  {
    "scenarioId": 15,
    "language": "es-US",
    "translations": {
      "context": "Lucas, un trabajador remoto de tu equipo, ha estado recientemente desconectado y sin responder durante el horario laboral, lo que ha causado problemas con solicitudes urgentes. Has programado una reunión con Lucas para abordar la situación.",
      "keyDetails": [
        {
          "text": "Lucas ha estado desconectado y sin responder durante el horario laboral"
        },
        {
          "text": "Por ejemplo, no respondió la semana pasada cuando necesitabas su opinión antes de una reunión el mismo día. Tampoco respondió durante toda la mañana hace unos días, a pesar de que su calendario estaba libre.\n"
        },
        {
          "text": "Necesitas aclarar las expectativas de disponibilidad"
        },
        {
          "text": "Comprender la perspectiva de Lucas sobre el trabajo flexible"
        },
        {
          "text": "Encontrar un equilibrio entre flexibilidad y capacidad de respuesta"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Proporcionar ejemplos específicos de problemas de disponibilidad y su impacto"
        },
        {
          "text": "Escuchar la perspectiva de Lucas sobre el trabajo flexible"
        },
        {
          "text": "Discutir la importancia de estar localizable durante las horas centrales"
        },
        {
          "text": "Desarrollar colaborativamente un plan para mejorar la disponibilidad"
        }
      ],
      "objectives": [
        {
          "text": "Abordar los problemas de disponibilidad de Lucas y establecer expectativas claras para la disponibilidad en el trabajo remoto"
        },
        {
          "text": "Acordar con Lucas cómo puede mejorar su comunicación mientras trabaja de forma remota"
        }
      ]
    }
  },
  {
    "scenarioId": 16,
    "language": "cmn-CN",
    "translations": {
      "context": "Dom，一位直接下属，在领养了他的孩子 Ava 后，休了几个月的育儿假，现在即将重返工作岗位。他很高兴能回来，但也对平衡工作和家庭生活感到紧张。你已经安排了一次与 Dom 的会议，欢迎他回来并支持他重返工作岗位。",
      "keyDetails": [
        {
          "text": "Dom 在休了几个月的育儿假后重返工作岗位。"
        },
        {
          "text": "他最近领养了一个名叫 Ava 的孩子。"
        },
        {
          "text": "Dom 对他的回归既兴奋又紧张。"
        },
        {
          "text": "他需要了解工作进展的最新情况，例如他将从他的育儿假替补那里接手一个新项目。"
        },
        {
          "text": "Dom 对平衡工作和家庭责任感到担忧；他希望更多地在家工作。"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "热情欢迎 Dom 回归，并询问他的家人情况。"
        },
        {
          "text": "向 Dom 提供任何关键更新，并安排他与育儿假替补会面。"
        },
        {
          "text": "讨论 Dom 可能需要的任何便利，包括增加在家工作时间的可能性。"
        },
        {
          "text": "解决 Dom 对工作与生活平衡的担忧，包括睡眠不足。"
        },
        {
          "text": "制定一个逐步增加 Dom 工作量并定期进行沟通的计划。"
        }
      ],
      "objectives": [
        {
          "text": "确保 Dom 在育儿假后重返工作岗位时，能够顺利且得到支持地过渡。"
        },
        {
          "text": "解决 Dom 的担忧，并帮助他在平衡工作和家庭方面取得成功。\n"
        }
      ]
    }
  },
  {
    "scenarioId": 16,
    "language": "de-DE",
    "translations": {
      "context": "Dom, ein direkter Mitarbeiter, kehrt nach mehrmonatiger Elternzeit, die er nach der Adoption seines Babys Ava genommen hat, an den Arbeitsplatz zurück. Er freut sich auf seine Rückkehr, ist aber auch nervös, wie er Arbeit und Familienleben unter einen Hut bringen soll. Sie haben ein Treffen mit Dom vereinbart, um ihn willkommen zu heißen und ihn bei der Rückkehr in seine Rolle zu unterstützen.",
      "keyDetails": [
        {
          "text": "Dom kehrt nach mehrmonatiger Elternzeit zurück"
        },
        {
          "text": "Er hat kürzlich ein Baby namens Ava adoptiert"
        },
        {
          "text": "Dom ist gespannt, aber auch nervös wegen seiner Rückkehr"
        },
        {
          "text": "Er benötigt Updates zu den Arbeitsentwicklungen, z.B. wird er ein neues Projekt von seiner Elternzeitvertretung übernehmen"
        },
        {
          "text": "Dom hat Bedenken hinsichtlich der Vereinbarkeit von Berufs- und Familienpflichten; er möchte mehr von zu Hause aus arbeiten"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Dom herzlich willkommen heißen und sich nach seiner Familie erkundigen"
        },
        {
          "text": "Dom wichtige Updates geben und ein Treffen mit seiner Elternzeitvertretung vereinbaren"
        },
        {
          "text": "Eventuelle Anpassungen besprechen, die Dom benötigen könnte, einschließlich der Möglichkeit, mehr von zu Hause aus zu arbeiten"
        },
        {
          "text": "Doms Bedenken bezüglich der Work-Life-Balance ansprechen, einschließlich Schlafmangel"
        },
        {
          "text": "Einen Plan für die schrittweise Erhöhung von Doms Arbeitslast erstellen und regelmäßige Check-ins vereinbaren"
        }
      ],
      "objectives": [
        {
          "text": "Einen reibungslosen und unterstützenden Übergang für Dom nach seiner Rückkehr aus der Elternzeit gewährleisten"
        },
        {
          "text": "Doms Bedenken ansprechen und ihn dabei unterstützen, Arbeit und Familie erfolgreich zu vereinbaren\n"
        }
      ]
    }
  },
  {
    "scenarioId": 16,
    "language": "es-US",
    "translations": {
      "context": "Dom, un subordinado directo, regresa al trabajo después de varios meses de licencia parental tras la adopción de su bebé, Ava. Está emocionado de regresar, pero también nervioso por equilibrar el trabajo y la vida familiar. Has programado una reunión con Dom para darle la bienvenida y apoyarlo en su regreso a su puesto.",
      "keyDetails": [
        {
          "text": "Dom regresa de varios meses de licencia parental"
        },
        {
          "text": "Recientemente adoptó una bebé llamada Ava"
        },
        {
          "text": "Dom está emocionado pero nervioso por su regreso"
        },
        {
          "text": "Necesita actualizaciones sobre los desarrollos del trabajo, por ejemplo, asumirá un nuevo proyecto de la persona que lo cubrió durante su licencia parental"
        },
        {
          "text": "Dom tiene preocupaciones sobre cómo equilibrar las responsabilidades laborales y familiares; le gustaría trabajar más desde casa"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Dale una cálida bienvenida a Dom y pregúntale por su familia"
        },
        {
          "text": "Proporciona a Dom las actualizaciones clave y organiza una reunión con la persona que lo cubrió durante su licencia parental"
        },
        {
          "text": "Discute cualquier adaptación que Dom pueda necesitar, incluida la posibilidad de aumentar el tiempo de trabajo desde casa"
        },
        {
          "text": "Aborda las preocupaciones de Dom sobre el equilibrio entre el trabajo y la vida personal, incluida la falta de sueño"
        },
        {
          "text": "Establece un plan para aumentar gradualmente la carga de trabajo de Dom y programa revisiones periódicas"
        }
      ],
      "objectives": [
        {
          "text": "Asegurar una transición fluida y de apoyo para Dom a su regreso al trabajo después de la licencia parental"
        },
        {
          "text": "Abordar las preocupaciones de Dom y prepararlo para el éxito en el equilibrio entre el trabajo y la familia\n"
        }
      ]
    }
  },
  {
    "scenarioId": 17,
    "language": "cmn-CN",
    "translations": {
      "context": "Rose，你的下属，最近被诊断出患有ADHD（注意缺陷多动障碍）。她通过电子邮件与你分享了这一诊断结果，并要求召开一次会议，更详细地讨论相关事宜，特别是你如何帮助满足她的需求。",
      "keyDetails": [
        {
          "text": "Rose最近被诊断出患有ADHD"
        },
        {
          "text": "她希望讨论如何为她的工作需求提供便利"
        },
        {
          "text": "Rose有兴趣利用她与ADHD相关的优势"
        },
        {
          "text": "你需要表现出支持和理解"
        },
        {
          "text": "目标是制定一个既能让Rose受益，又能让组织受益的行动计划"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "欢迎Rose，并对她分享这一信息表示支持"
        },
        {
          "text": "倾听Rose对她的诊断及其对工作影响的看法"
        },
        {
          "text": "讨论Rose可能需要的潜在便利措施"
        },
        {
          "text": "探讨Rose与ADHD相关的优势以及如何利用它们"
        },
        {
          "text": "共同制定一个行动计划，以实施支持她的改变"
        }
      ],
      "objectives": [
        {
          "text": "确保就Rose的ADHD诊断进行一次支持性和富有成效的讨论"
        },
        {
          "text": "共同讨论提供便利和利用Rose优势的方案"
        }
      ]
    }
  },
  {
    "scenarioId": 17,
    "language": "de-DE",
    "translations": {
      "context": "Rose, eine direkte Mitarbeiterin, hat kürzlich eine ADHS-Diagnose erhalten. Sie hat Ihnen die Diagnose per E-Mail mitgeteilt, aber um ein Treffen gebeten, um die Dinge detaillierter zu besprechen, insbesondere wie Sie ihr bei der Berücksichtigung ihrer Bedürfnisse helfen können.",
      "keyDetails": [
        {
          "text": "Rose hat kürzlich eine ADHS-Diagnose erhalten"
        },
        {
          "text": "Sie möchte über Anpassungen für ihre Arbeitsbedürfnisse sprechen"
        },
        {
          "text": "Rose ist daran interessiert, ihre ADHS-bedingten Stärken zu nutzen"
        },
        {
          "text": "Sie müssen unterstützend und verständnisvoll sein"
        },
        {
          "text": "Das Ziel ist es, einen Aktionsplan zu erstellen, der sowohl Rose als auch der Organisation zugutekommt"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Rose willkommen heißen und Unterstützung für das Teilen dieser Information ausdrücken"
        },
        {
          "text": "Roses Perspektive zu ihrer Diagnose und deren Auswirkungen auf ihre Arbeit anhören"
        },
        {
          "text": "Mögliche Anpassungen besprechen, die Rose benötigen könnte"
        },
        {
          "text": "Roses ADHS-bedingte Stärken erkunden und wie man sie nutzen kann"
        },
        {
          "text": "Gemeinsam einen Aktionsplan zur Umsetzung von Änderungen zur Unterstützung von Rose entwickeln"
        }
      ],
      "objectives": [
        {
          "text": "Eine unterstützende und produktive Diskussion über Roses ADHS-Diagnose gewährleisten"
        },
        {
          "text": "Gemeinsam Ideen für Anpassungen und die Nutzung von Roses Stärken besprechen"
        }
      ]
    }
  },
  {
    "scenarioId": 17,
    "language": "es-US",
    "translations": {
      "context": "Rose, una colaboradora directa, ha recibido recientemente un diagnóstico de TDAH. Compartió el diagnóstico contigo por correo electrónico, pero ha solicitado una reunión para discutir las cosas con más detalle, específicamente sobre cómo puedes ayudar a satisfacer sus necesidades.",
      "keyDetails": [
        {
          "text": "Rose ha recibido recientemente un diagnóstico de TDAH"
        },
        {
          "text": "Quiere discutir adaptaciones para sus necesidades laborales"
        },
        {
          "text": "Rose está interesada en aprovechar sus fortalezas relacionadas con el TDAH"
        },
        {
          "text": "Debes ser comprensivo y brindar apoyo"
        },
        {
          "text": "El objetivo es crear un plan de acción que beneficie tanto a Rose como a la organización"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Dar la bienvenida a Rose y expresar apoyo por haber compartido esta información"
        },
        {
          "text": "Escuchar la perspectiva de Rose sobre su diagnóstico y su impacto en su trabajo"
        },
        {
          "text": "Discutir posibles adaptaciones que Rose podría necesitar"
        },
        {
          "text": "Explorar las fortalezas de Rose relacionadas con el TDAH y cómo aprovecharlas"
        },
        {
          "text": "Desarrollar colaborativamente un plan de acción para implementar cambios que la apoyen"
        }
      ],
      "objectives": [
        {
          "text": "Asegurar una discusión de apoyo y productiva sobre el diagnóstico de TDAH de Rose"
        },
        {
          "text": "Discutir colaborativamente ideas para adaptaciones y el aprovechamiento de las fortalezas de Rose"
        }
      ]
    }
  },
  {
    "scenarioId": 2,
    "language": "cmn-CN",
    "translations": {
      "context": "您的一位直接下属 Morgan 一直与另一位团队成员 Taylor 存在持续的冲突。这些冲突影响了团队士气和生产力。您已安排与 Morgan 进行一次谈话以讨论此情况。",
      "keyDetails": [
        {
          "text": "Morgan 认为 Taylor 窃取了她的工作成果并冒充是自己的"
        },
        {
          "text": "冲突正在影响 Morgan 的工作表现和积极性"
        },
        {
          "text": "您也注意到冲突影响了团队动态"
        },
        {
          "text": "您已安排会议以了解 Morgan 的观点"
        },
        {
          "text": "您希望帮助 Morgan 解决与 Taylor 的问题"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开启对话并解释会议目的"
        },
        {
          "text": "允许 Morgan 表达他们的不满和担忧，并提供具体示例"
        },
        {
          "text": "讨论冲突对 Morgan 的工作和团队的影响"
        },
        {
          "text": "探讨 Morgan 改善情况的想法并提出潜在解决方案"
        },
        {
          "text": "合作制定行动计划，明确期望和后续步骤"
        }
      ],
      "objectives": [
        {
          "text": "了解 Morgan 和 Taylor 之间冲突的性质，以及它对 Morgan 的影响"
        },
        {
          "text": "积极倾听 Morgan 的担忧，并引导对话走向寻找建设性解决方案"
        }
      ]
    }
  },
  {
    "scenarioId": 2,
    "language": "de-DE",
    "translations": {
      "context": "Eine Ihrer direkten Untergebenen, Morgan, hat anhaltende Konflikte mit einem anderen Teammitglied, Taylor. Die Konflikte beeinträchtigen die Teamstimmung und Produktivität. Sie haben ein Gespräch mit Morgan angesetzt, um die Situation zu besprechen.",
      "keyDetails": [
        {
          "text": "Morgan glaubt, dass Taylor ihre Arbeit stiehlt und als ihre eigene ausgibt."
        },
        {
          "text": "Der Konflikt beeinträchtigt Morgans Arbeitsleistung und Motivation."
        },
        {
          "text": "Sie haben auch bemerkt, dass der Konflikt die Teamdynamik beeinflusst hat."
        },
        {
          "text": "Sie haben das Treffen angesetzt, um Morgans Perspektive zu verstehen."
        },
        {
          "text": "Sie möchten Morgan helfen, das Problem mit Taylor zu lösen."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Eröffnen Sie das Gespräch und erläutern Sie den Zweck des Treffens."
        },
        {
          "text": "Geben Sie Morgan die Möglichkeit, ihre Frustrationen und Bedenken mit konkreten Beispielen auszudrücken."
        },
        {
          "text": "Besprechen Sie die Auswirkungen des Konflikts auf Morgans Arbeit und das Team."
        },
        {
          "text": "Erforschen Sie Morgans Ideen zur Verbesserung der Situation und präsentieren Sie mögliche Lösungen."
        },
        {
          "text": "Arbeiten Sie gemeinsam an der Entwicklung eines Aktionsplans mit klaren Erwartungen und Folgeschritten."
        }
      ],
      "objectives": [
        {
          "text": "Verstehen Sie die Art des Konflikts zwischen Morgan und Taylor und die Auswirkungen, die er auf Morgan hat."
        },
        {
          "text": "Hören Sie Morgans Bedenken aktiv zu und lenken Sie das Gespräch auf konstruktive Lösungen."
        }
      ]
    }
  },
  {
    "scenarioId": 2,
    "language": "es-US",
    "translations": {
      "context": "Uno de tus colaboradores directos, Morgan, ha estado teniendo conflictos continuos con otro miembro del equipo, Taylor. Los conflictos han estado afectando la moral y la productividad del equipo. Has programado una conversación con Morgan para discutir la situación.",
      "keyDetails": [
        {
          "text": "Morgan cree que Taylor le está robando su trabajo y haciéndolo pasar como propio"
        },
        {
          "text": "El conflicto está afectando el rendimiento y la motivación de Morgan"
        },
        {
          "text": "También has notado que el conflicto ha estado afectando la dinámica del equipo"
        },
        {
          "text": "Has programado la reunión para entender la perspectiva de Morgan"
        },
        {
          "text": "Quieres ayudar a Morgan a resolver el problema con Taylor"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Permitir que Morgan exprese sus frustraciones y preocupaciones con ejemplos específicos"
        },
        {
          "text": "Discutir el impacto del conflicto en el trabajo de Morgan y en el equipo"
        },
        {
          "text": "Explorar las ideas de Morgan para mejorar la situación y presentar posibles soluciones"
        },
        {
          "text": "Colaborar en el desarrollo de un plan de acción con expectativas claras y pasos de seguimiento"
        }
      ],
      "objectives": [
        {
          "text": "Comprender la naturaleza del conflicto entre Morgan y Taylor, y el impacto que está teniendo en Morgan"
        },
        {
          "text": "Escuchar activamente las preocupaciones de Morgan y guiar la conversación hacia la búsqueda de soluciones constructivas"
        }
      ]
    }
  },
  {
    "scenarioId": 20,
    "language": "cmn-CN",
    "translations": {
      "context": "Morgan是您团队中一名优秀的员工，但她未能获得她申请的内部晋升。她还没有完全准备好承担这个更高的职位，但公司很重视她，她也具备未来的发展潜力。您安排了这次会议来告知她这个消息。",
      "keyDetails": [
        {
          "text": "Morgan未能获得她申请的晋升"
        },
        {
          "text": "她是一名优秀的员工，具备未来的发展潜力"
        },
        {
          "text": "您需要在她感到失望的情况下保持她的积极性"
        },
        {
          "text": "提供关于发展领域的建设性反馈（例如，提高她在给客户的电子邮件中的书面沟通技巧）"
        },
        {
          "text": "为她未来的成长和发展规划路径"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "以同理心开启对话，并肯定Morgan的努力"
        },
        {
          "text": "清晰地传达关于晋升的决定"
        },
        {
          "text": "提供关于发展领域的具体反馈（例如，提高她在给客户的电子邮件中的书面沟通技巧）"
        },
        {
          "text": "讨论Morgan对公司的价值和未来的潜力"
        },
        {
          "text": "共同制定未来的成长和发展计划"
        }
      ],
      "objectives": [
        {
          "text": "在保持积极氛围的同时，传达晋升申请未成功的消息"
        },
        {
          "text": "提供建设性反馈并为Morgan未来的成长制定计划"
        }
      ]
    }
  },
  {
    "scenarioId": 20,
    "language": "de-DE",
    "translations": {
      "context": "Morgan, eine gute Mitarbeiterin in Ihrem Team, hat die interne Beförderung, auf die sie sich beworben hatte, nicht erhalten. Sie war noch nicht ganz bereit für diesen Schritt nach oben, wird aber vom Unternehmen geschätzt und hat Potenzial für zukünftige Weiterentwicklung. Sie haben dieses Treffen angesetzt, um ihr die Nachricht zu überbringen.",
      "keyDetails": [
        {
          "text": "Morgan hat die Beförderung, auf die sie sich beworben hatte, nicht erhalten"
        },
        {
          "text": "Sie ist eine gute Mitarbeiterin mit Potenzial für zukünftige Weiterentwicklung"
        },
        {
          "text": "Sie müssen ihre Motivation trotz der Enttäuschung aufrechterhalten"
        },
        {
          "text": "Konstruktives Feedback zu Entwicklungsbereichen geben (z.B. Verbesserung ihrer schriftlichen Kommunikationsfähigkeiten in E-Mails an Kunden)"
        },
        {
          "text": "Einen Weg für ihre zukünftige Entwicklung und ihr Wachstum aufzeigen"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch mit Empathie beginnen und Morgans Bemühungen anerkennen"
        },
        {
          "text": "Die Entscheidung bezüglich der Beförderung klar kommunizieren"
        },
        {
          "text": "Spezifisches Feedback zu Entwicklungsbereichen geben (z.B. Verbesserung der schriftlichen Kommunikationsfähigkeiten in E-Mails an Kunden)"
        },
        {
          "text": "Morgans Wert für das Unternehmen und ihr zukünftiges Potenzial besprechen"
        },
        {
          "text": "Gemeinsam einen Plan für zukünftiges Wachstum und Entwicklung erarbeiten"
        }
      ],
      "objectives": [
        {
          "text": "Die erfolglose Beförderungsbewerbung kommunizieren und dabei eine positive Atmosphäre aufrechterhalten"
        },
        {
          "text": "Konstruktives Feedback geben und einen Plan für Morgans zukünftiges Wachstum entwickeln"
        }
      ]
    }
  },
  {
    "scenarioId": 20,
    "language": "es-US",
    "translations": {
      "context": "Morgan, una buena empleada de tu equipo, no ha recibido la promoción interna a la que postuló. Aunque no estaba del todo lista para este ascenso, es valorada por la empresa y tiene potencial para futuros avances. Has programado esta reunión para darle la noticia.",
      "keyDetails": [
        {
          "text": "Morgan no recibió la promoción a la que postuló"
        },
        {
          "text": "Es una buena empleada con potencial para futuros ascensos"
        },
        {
          "text": "Necesitas mantener su motivación a pesar de la decepción"
        },
        {
          "text": "Proporcionar retroalimentación constructiva sobre áreas de desarrollo (por ejemplo, mejorar sus habilidades de comunicación escrita en sus correos electrónicos a clientes)"
        },
        {
          "text": "Esbozar un camino para su crecimiento y desarrollo futuro"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación con empatía y reconocer los esfuerzos de Morgan"
        },
        {
          "text": "Comunicar claramente la decisión sobre la promoción"
        },
        {
          "text": "Proporcionar retroalimentación específica sobre áreas de desarrollo (por ejemplo, mejorar las habilidades de comunicación escrita en sus correos electrónicos a clientes)"
        },
        {
          "text": "Discutir el valor de Morgan para la empresa y su potencial futuro"
        },
        {
          "text": "Desarrollar colaborativamente un plan para el crecimiento y desarrollo futuro"
        }
      ],
      "objectives": [
        {
          "text": "Comunicar la postulación fallida a la promoción manteniendo un ambiente positivo"
        },
        {
          "text": "Proporcionar retroalimentación constructiva y desarrollar un plan para el crecimiento futuro de Morgan"
        }
      ]
    }
  },
  {
    "scenarioId": 21,
    "language": "cmn-CN",
    "translations": {
      "context": "Ollie，你团队的一员，今年将不会获得奖金，原因是他表现尚可（但并非出色），以及公司在充满挑战的经济环境下缺乏增长。\n\n你已经安排了与Ollie的会议，以告知他这个消息。Ollie知道这次会议是关于他的奖金决定，但他尚未提前得知结果。",
      "keyDetails": [
        {
          "text": "Ollie今年将不会获得奖金"
        },
        {
          "text": "他的表现尚可，但并非出色"
        },
        {
          "text": "公司缺乏增长也是一个因素"
        },
        {
          "text": "你需要处理他可能出现的失望或愤怒情绪"
        },
        {
          "text": "解释他需要承担更多责任，以增加明年获得奖金的机会"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开启对话，清晰并富有同情心地传达消息"
        },
        {
          "text": "解释决定背后的原因（个人表现和公司业绩）"
        },
        {
          "text": "倾听并认可Ollie的反应"
        },
        {
          "text": "讨论具体的绩效改进领域，例如承担更多责任"
        },
        {
          "text": "概述明年获得奖金的期望"
        }
      ],
      "objectives": [
        {
          "text": "富有同理心地传达未获得奖金的消息"
        },
        {
          "text": "安排一次后续会议以制定详细的改进计划"
        }
      ]
    }
  },
  {
    "scenarioId": 21,
    "language": "de-DE",
    "translations": {
      "context": "Ollie, ein Mitglied Ihres Teams, erhält dieses Jahr keinen Bonus aufgrund seiner zufriedenstellenden (aber nicht außergewöhnlichen) Leistung und des mangelnden Wachstums des Unternehmens in einer herausfordernden Wirtschaftslage. \n\nSie haben ein Treffen mit Ollie vereinbart, um ihn über diese Neuigkeit zu informieren. Ollie weiß, dass es bei dem Treffen um seine Bonusentscheidung geht, aber das Ergebnis wurde ihm im Voraus nicht mitgeteilt.",
      "keyDetails": [
        {
          "text": "Ollie erhält dieses Jahr keinen Bonus."
        },
        {
          "text": "Seine Leistung war zufriedenstellend, aber nicht außergewöhnlich."
        },
        {
          "text": "Das mangelnde Wachstum des Unternehmens ist ebenfalls ein Faktor."
        },
        {
          "text": "Sie müssen mit potenzieller Enttäuschung oder Wut umgehen."
        },
        {
          "text": "Erklären Sie, dass er mehr Verantwortung übernehmen muss, um seine Chancen auf einen Bonus im nächsten Jahr zu erhöhen."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Eröffnen Sie das Gespräch und übermitteln Sie die Nachricht klar und einfühlsam."
        },
        {
          "text": "Erläutern Sie die Gründe für die Entscheidung (individuelle und Unternehmensleistung)."
        },
        {
          "text": "Hören Sie Ollies Reaktion zu und nehmen Sie sie zur Kenntnis."
        },
        {
          "text": "Besprechen Sie spezifische Bereiche zur Leistungsverbesserung, wie z.B. die Übernahme von mehr Verantwortung."
        },
        {
          "text": "Skizzieren Sie die Erwartungen für den Erhalt eines Bonus im nächsten Jahr."
        }
      ],
      "objectives": [
        {
          "text": "Übermitteln Sie die Nachricht über den fehlenden Bonus einfühlsam."
        },
        {
          "text": "Vereinbaren Sie ein Folgetreffen, um einen detaillierten Verbesserungsplan zu erstellen."
        }
      ]
    }
  },
  {
    "scenarioId": 21,
    "language": "es-US",
    "translations": {
      "context": "Ollie, un miembro de su equipo, no recibirá un bono este año debido a su desempeño satisfactorio (pero no excepcional) y a la falta de crecimiento de la empresa en una economía desafiante. \n\nUsted ha programado una reunión con Ollie para informarle la noticia. Ollie sabe que la reunión es sobre la decisión de su bono, pero no se le ha comunicado el resultado de antemano.",
      "keyDetails": [
        {
          "text": "Ollie no recibirá un bono este año"
        },
        {
          "text": "Su desempeño fue satisfactorio pero no excepcional"
        },
        {
          "text": "La falta de crecimiento de la empresa también es un factor"
        },
        {
          "text": "Debe manejar la posible decepción o enojo"
        },
        {
          "text": "Explique que necesita asumir más responsabilidades para aumentar sus posibilidades de recibir un bono el próximo año"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Inicie la conversación y comunique la noticia de manera clara y empática"
        },
        {
          "text": "Explique las razones detrás de la decisión (desempeño individual y de la empresa)"
        },
        {
          "text": "Escuche y reconozca la reacción de Ollie"
        },
        {
          "text": "Discuta áreas específicas para la mejora del desempeño, como asumir más responsabilidades"
        },
        {
          "text": "Describa las expectativas para recibir un bono el próximo año"
        }
      ],
      "objectives": [
        {
          "text": "Comunicar la noticia sobre la falta de bono de manera empática"
        },
        {
          "text": "Programar una reunión de seguimiento para crear un plan de mejora detallado"
        }
      ]
    }
  },
  {
    "scenarioId": 22,
    "language": "cmn-CN",
    "translations": {
      "context": "Hannah，你团队的一员，正在为她的工作量而挣扎，感到不堪重负。她给你发了一封邮件，请求开会讨论这种情况。",
      "keyDetails": [
        {
          "text": "Hannah正在为她的工作量而挣扎，感到不堪重负"
        },
        {
          "text": "她难以优先处理任务"
        },
        {
          "text": "Hannah觉得她因此什么都完不成"
        },
        {
          "text": "她担心让团队失望"
        },
        {
          "text": "目标是支持她管理工作量并减轻压力        \n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "以同理心开启对话，并认可Hannah的担忧"
        },
        {
          "text": "倾听Hannah对她工作量挑战的看法"
        },
        {
          "text": "帮助Hannah优先处理她的任务"
        },
        {
          "text": "讨论更好的时间管理和减压策略，例如开启“请勿打扰”模式，并为重要任务在日历上预留时间"
        },
        {
          "text": "提供支持和资源以帮助管理工作量\n"
        }
      ],
      "objectives": [
        {
          "text": "倾听Hannah的担忧并支持她管理工作量"
        },
        {
          "text": "制定计划帮助Hannah管理压力并提高生产力"
        }
      ]
    }
  },
  {
    "scenarioId": 22,
    "language": "de-DE",
    "translations": {
      "context": "Hannah, ein Mitglied Ihres Teams, kämpft mit ihrer Arbeitslast und fühlt sich überfordert. Sie hat Ihnen eine E-Mail geschickt, in der sie um ein Treffen bittet, um die Situation zu besprechen.",
      "keyDetails": [
        {
          "text": "Hannah kämpft mit ihrer Arbeitslast und fühlt sich überfordert"
        },
        {
          "text": "Sie hat Schwierigkeiten, Aufgaben zu priorisieren"
        },
        {
          "text": "Hannah hat das Gefühl, dadurch nichts zu erledigen"
        },
        {
          "text": "Sie macht sich Sorgen, das Team im Stich zu lassen"
        },
        {
          "text": "Das Ziel ist, sie bei der Bewältigung der Arbeitslast und der Reduzierung von Stress zu unterstützen        \n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Beginnen Sie das Gespräch mit Empathie und nehmen Sie Hannahs Bedenken ernst"
        },
        {
          "text": "Hören Sie Hannahs Perspektive zu ihren Herausforderungen bei der Arbeitslast"
        },
        {
          "text": "Helfen Sie Hannah, ihre Aufgaben zu priorisieren"
        },
        {
          "text": "Besprechen Sie Strategien für besseres Zeitmanagement und Stressabbau, wie das Aktivieren von 'Nicht stören' und das Blockieren ihres Kalenders für wichtige Aufgaben"
        },
        {
          "text": "Bieten Sie Unterstützung und Ressourcen zur Bewältigung der Arbeitslast an\n"
        }
      ],
      "objectives": [
        {
          "text": "Hören Sie Hannahs Bedenken zu und unterstützen Sie sie bei der Bewältigung ihrer Arbeitslast"
        },
        {
          "text": "Entwickeln Sie einen Plan, um Hannah bei der Stressbewältigung und Produktivitätssteigerung zu helfen"
        }
      ]
    }
  },
  {
    "scenarioId": 22,
    "language": "es-US",
    "translations": {
      "context": "Hannah, una miembro de tu equipo, está teniendo dificultades con su carga de trabajo y se siente abrumada. Te ha enviado un correo electrónico solicitando una reunión para discutir la situación.",
      "keyDetails": [
        {
          "text": "Hannah está teniendo dificultades con su carga de trabajo y se siente abrumada"
        },
        {
          "text": "Está teniendo dificultades para priorizar tareas"
        },
        {
          "text": "Hannah siente que, como resultado, no está completando nada"
        },
        {
          "text": "Le preocupa decepcionar al equipo"
        },
        {
          "text": "El objetivo es apoyarla en la gestión de la carga de trabajo y la reducción del estrés        \n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Inicia la conversación con empatía y reconoce las preocupaciones de Hannah"
        },
        {
          "text": "Escucha la perspectiva de Hannah sobre sus desafíos con la carga de trabajo"
        },
        {
          "text": "Ayuda a Hannah a priorizar sus tareas"
        },
        {
          "text": "Discute estrategias para una mejor gestión del tiempo y reducción del estrés, como activar No Molestar y bloquear su calendario para tareas importantes"
        },
        {
          "text": "Ofrece apoyo y recursos para ayudar a gestionar la carga de trabajo\n"
        }
      ],
      "objectives": [
        {
          "text": "Escucha las preocupaciones de Hannah y apóyala en la gestión de su carga de trabajo"
        },
        {
          "text": "Desarrolla un plan para ayudar a Hannah a manejar el estrés y mejorar la productividad"
        }
      ]
    }
  },
  {
    "scenarioId": 23,
    "language": "cmn-CN",
    "translations": {
      "context": "你的团队成员 Sarah 似乎比以前投入度低了很多。尽管她仍然按时完成分配的任务，但她的工作常常给人一种敷衍了事的感觉。她对自己的角色表现出很少的热情，也很少参与基本职责之外的工作，而以前她总是团队中那个积极主动、超越期望的人。\n\n你已经和 Sarah 安排了一次会议，以了解是什么原因导致了这种变化，并看看你是否能提供帮助。Sarah 不知道这次会议的主题。",
      "keyDetails": [
        {
          "text": "Sarah 按时完成任务，但投入的精力很少\n"
        },
        {
          "text": "她很少参与基本职责之外的工作\n"
        },
        {
          "text": "她似乎与公司的使命脱节\n"
        },
        {
          "text": "她已停止参加可选会议或工作社交活动"
        },
        {
          "text": "你希望找到方法重新激发她的热情"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并解释会议目的"
        },
        {
          "text": "询问 Sarah 目前对工作和公司的感受"
        },
        {
          "text": "倾听 Sarah 对其投入度降低的看法"
        },
        {
          "text": "讨论投入度对团队活力和成功的影响"
        },
        {
          "text": "共同探讨重新激发 Sarah 热情的策略"
        }
      ],
      "objectives": [
        {
          "text": "在保持支持和激励氛围的同时，解决投入度低的问题"
        },
        {
          "text": "共同讨论提升 Sarah 投入度和热情的想法"
        }
      ]
    }
  },
  {
    "scenarioId": 23,
    "language": "de-DE",
    "translations": {
      "context": "Sarah, ein Mitglied Ihres Teams, wirkt deutlich weniger engagiert als früher. Obwohl sie zugewiesene Aufgaben immer noch pünktlich erledigt, wirkt ihre Arbeit oft wie das absolute Minimum. Sie zeigt wenig Begeisterung für ihre Rolle und engagiert sich selten über die grundlegenden Aufgaben hinaus, wohingegen sie früher die Person in Ihrem Team war, die immer über das Übliche hinausging. \n\nSie haben ein Treffen mit Sarah vereinbart, um zu verstehen, was diese Veränderung antreibt, und um zu sehen, ob Sie helfen können. Sarah weiß nicht, worum es bei dem Treffen geht.",
      "keyDetails": [
        {
          "text": "Sarah erledigt Aufgaben pünktlich, zeigt aber minimalen Einsatz\n"
        },
        {
          "text": "Sie engagiert sich selten über grundlegende Aufgaben hinaus\n"
        },
        {
          "text": "Sie scheint von der Mission der Organisation entfremdet zu sein\n"
        },
        {
          "text": "Sie nimmt nicht mehr an optionalen Besprechungen oder betrieblichen Veranstaltungen teil"
        },
        {
          "text": "Sie möchten Wege finden, ihren Enthusiasmus neu zu beleben"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Eröffnen Sie das Gespräch und erläutern Sie den Zweck des Treffens"
        },
        {
          "text": "Fragen Sie nach Sarahs aktuellen Gefühlen bezüglich ihrer Arbeit und der Organisation"
        },
        {
          "text": "Hören Sie Sarahs Perspektive zu ihrem reduzierten Engagement an"
        },
        {
          "text": "Besprechen Sie die Auswirkungen von Engagement auf Teamdynamik und Erfolg"
        },
        {
          "text": "Erkunden Sie gemeinsam Strategien, um Sarahs Enthusiasmus neu zu entfachen"
        }
      ],
      "objectives": [
        {
          "text": "Das Problem des geringen Engagements ansprechen, während eine unterstützende und motivierende Atmosphäre aufrechterhalten wird"
        },
        {
          "text": "Gemeinsam Ideen zur Steigerung von Sarahs Engagement und Enthusiasmus besprechen"
        }
      ]
    }
  },
  {
    "scenarioId": 23,
    "language": "es-US",
    "translations": {
      "context": "Sarah, miembro de tu equipo, parece mucho menos comprometida de lo que solía estar. Aunque sigue completando las tareas asignadas a tiempo, su trabajo a menudo se siente como el mínimo indispensable. Muestra poco entusiasmo por su rol y rara vez se involucra más allá de sus responsabilidades básicas, mientras que antes era la persona de tu equipo que siempre iba más allá. \n\nHas programado una reunión con Sarah para entender si hay algo que esté impulsando este cambio y para ver si puedes ayudar. Sarah no sabe de qué trata la reunión.",
      "keyDetails": [
        {
          "text": "Sarah completa las tareas a tiempo, pero muestra un esfuerzo mínimo\n"
        },
        {
          "text": "Rara vez se involucra más allá de sus responsabilidades básicas\n"
        },
        {
          "text": "Parece desconectada de la misión de la organización\n"
        },
        {
          "text": "Ha dejado de asistir a reuniones opcionales o eventos sociales de trabajo"
        },
        {
          "text": "Te gustaría encontrar formas de reavivar su entusiasmo"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Preguntar sobre los sentimientos actuales de Sarah hacia su trabajo y la organización"
        },
        {
          "text": "Escuchar la perspectiva de Sarah sobre su menor compromiso"
        },
        {
          "text": "Discutir el impacto del compromiso en la dinámica y el éxito del equipo"
        },
        {
          "text": "Explorar colaborativamente estrategias para reavivar el entusiasmo de Sarah"
        }
      ],
      "objectives": [
        {
          "text": "Abordar el problema del bajo compromiso manteniendo un ambiente de apoyo y motivación"
        },
        {
          "text": "Discutir colaborativamente ideas para mejorar el compromiso y el entusiasmo de Sarah"
        }
      ]
    }
  },
  {
    "scenarioId": 24,
    "language": "cmn-CN",
    "translations": {
      "context": "Nina，你的一名下属，刚刚失去了她的祖母，并给你发消息想聊聊请假的事情。这正值团队一个特别繁忙的时期，导致团队成员请假变得很困难。你已经和Nina安排了一次会议来讨论这个情况。",
      "keyDetails": [
        {
          "text": "Nina失去了她的祖母\n"
        },
        {
          "text": "她需要请假办理丧事\n"
        },
        {
          "text": "团队正处于繁忙时期\n"
        },
        {
          "text": "你需要平衡对她的支持与工作需求"
        },
        {
          "text": "你需要为Nina的请假和工作覆盖制定计划"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "对Nina的损失表达哀悼和同情\n"
        },
        {
          "text": "倾听Nina关于请假的需求\n"
        },
        {
          "text": "讨论当前的工作情况和优先事项\n"
        },
        {
          "text": "共同制定请假和工作覆盖计划\n"
        },
        {
          "text": "为Nina返岗提供支持和资源"
        }
      ],
      "objectives": [
        {
          "text": "在Nina悲伤期间向她提供支持和同情\n"
        },
        {
          "text": "为Nina的请假制定计划并管理工作职责"
        }
      ]
    }
  },
  {
    "scenarioId": 24,
    "language": "de-DE",
    "translations": {
      "context": "Nina, eine Ihrer direkten Mitarbeiterinnen, hat gerade ihre Großmutter verloren und Ihnen eine Nachricht geschickt, um über eine Auszeit zu sprechen. Dies geschieht während einer besonders arbeitsreichen Zeit für das Team, was es schwierig macht, dass ein Teammitglied abwesend ist. Sie haben ein Treffen mit Nina vereinbart, um die Situation zu besprechen.",
      "keyDetails": [
        {
          "text": "Nina hat ihre Großmutter verloren\n"
        },
        {
          "text": "Sie benötigt eine Auszeit wegen Trauerfalls\n"
        },
        {
          "text": "Es ist eine arbeitsreiche Zeit für das Team\n"
        },
        {
          "text": "Sie müssen Unterstützung mit den Arbeitsanforderungen in Einklang bringen"
        },
        {
          "text": "Sie müssen einen Plan für Ninas Abwesenheit und die Arbeitsabdeckung festlegen        "
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Drücken Sie Nina Ihr Beileid und Mitgefühl für ihren Verlust aus\n"
        },
        {
          "text": "Hören Sie Ninas Bedürfnissen bezüglich der Auszeit zu\n"
        },
        {
          "text": "Besprechen Sie die aktuelle Arbeitssituation und Prioritäten\n"
        },
        {
          "text": "Entwickeln Sie gemeinsam einen Plan für die Abwesenheit und Arbeitsabdeckung\n"
        },
        {
          "text": "Bieten Sie Unterstützung und Ressourcen für Ninas Rückkehr an"
        }
      ],
      "objectives": [
        {
          "text": "Bieten Sie Nina während ihres Trauerfalls Unterstützung und Mitgefühl\n"
        },
        {
          "text": "Entwickeln Sie einen Plan für Ninas Abwesenheit und managen Sie die Arbeitsaufgaben        "
        }
      ]
    }
  },
  {
    "scenarioId": 24,
    "language": "es-US",
    "translations": {
      "context": "Nina, una de tus subordinadas directas, acaba de perder a su abuela y te ha enviado un mensaje para hablar sobre tomarse un tiempo libre. Esto ocurre durante un período particularmente ocupado para el equipo, lo que dificulta que un miembro del equipo esté ausente del trabajo. Has programado una reunión con Nina para discutir la situación.",
      "keyDetails": [
        {
          "text": "Nina ha perdido a su abuela\n"
        },
        {
          "text": "Necesita tiempo libre por duelo\n"
        },
        {
          "text": "Es un período ocupado para el equipo\n"
        },
        {
          "text": "Necesitas equilibrar el apoyo con las necesidades del trabajo"
        },
        {
          "text": "Necesitas determinar un plan para la licencia de Nina y la cobertura del trabajo        "
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Expresar condolencias y pésame por la pérdida de Nina\n"
        },
        {
          "text": "Escuchar las necesidades de Nina con respecto al tiempo libre\n"
        },
        {
          "text": "Discutir la situación laboral actual y las prioridades\n"
        },
        {
          "text": "Desarrollar colaborativamente un plan para la licencia y la cobertura del trabajo\n"
        },
        {
          "text": "Ofrecer apoyo y recursos para el regreso de Nina"
        }
      ],
      "objectives": [
        {
          "text": "Brindar apoyo y pésame a Nina durante su duelo\n"
        },
        {
          "text": "Desarrollar un plan para la licencia de Nina y gestionar las responsabilidades laborales        "
        }
      ]
    }
  },
  {
    "scenarioId": 25,
    "language": "cmn-CN",
    "translations": {
      "context": "Nick 是你的一个下属。在最近一次新员工面试的复盘会议中，你注意到 Nick 对女性候选人的评价明显比对男性候选人更严苛。\n\n你已经和他安排了这次会议，讨论你认为存在的无意识偏见。Nick 知道这次会议是讨论面试情况的，但他并不知道你会提出这个具体问题。",
      "keyDetails": [
        {
          "text": "Nick 在最近的面试中对女性候选人表现出偏见"
        },
        {
          "text": "他对女性候选人的评分和评价比男性候选人更严苛"
        },
        {
          "text": "他在面试复盘会议中发表了不可接受的评论"
        },
        {
          "text": "例如，他评论说女性候选人很快就会去生孩子而离开"
        },
        {
          "text": "你希望 Nick 在保持建设性氛围的同时，理解他的偏见"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开启对话并解释会议目的"
        },
        {
          "text": "提供观察到的偏见行为的具体例子"
        },
        {
          "text": "解释无意识偏见的概念及其影响"
        },
        {
          "text": "讨论招聘中多元化和包容性的重要性"
        },
        {
          "text": "共同制定公平评估的策略"
        }
      ],
      "objectives": [
        {
          "text": "解决 Nick 在招聘过程中的无意识偏见，并促进包容性招聘实践"
        },
        {
          "text": "保持建设性和教育性的氛围"
        }
      ]
    }
  },
  {
    "scenarioId": 25,
    "language": "de-DE",
    "translations": {
      "context": "Nick ist einer Ihrer direkten Untergebenen. Bei den jüngsten Nachbesprechungen von Vorstellungsgesprächen für eine Neueinstellung haben Sie festgestellt, dass Nicks Kommentare gegenüber weiblichen Kandidatinnen deutlich härter waren als gegenüber männlichen Kandidaten. \n\nSie haben dieses Treffen mit ihm vereinbart, um zu besprechen, was Sie für eine unbewusste Voreingenommenheit halten. Nick weiß, dass es bei dem Treffen um die Vorstellungsgespräche geht, aber er weiß nicht, dass Sie dieses spezifische Thema ansprechen werden.",
      "keyDetails": [
        {
          "text": "Nick zeigte in den letzten Vorstellungsgesprächen eine Voreingenommenheit gegenüber weiblichen Kandidatinnen"
        },
        {
          "text": "Seine Bewertungen und Kommentare waren gegenüber Frauen härter als gegenüber männlichen Kandidaten"
        },
        {
          "text": "Er machte in den Nachbesprechungen der Vorstellungsgespräche inakzeptable Kommentare"
        },
        {
          "text": "Zum Beispiel bemerkte er, dass die weiblichen Kandidatinnen bald verschwinden würden, um Kinder zu bekommen"
        },
        {
          "text": "Sie möchten, dass Nick seine Voreingenommenheit versteht, während Sie eine konstruktive Atmosphäre aufrechterhalten"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Treffens erläutern"
        },
        {
          "text": "Spezifische Beispiele für beobachtetes voreingenommenes Verhalten anführen"
        },
        {
          "text": "Das Konzept der unbewussten Voreingenommenheit und ihre Auswirkungen erläutern"
        },
        {
          "text": "Die Bedeutung von Vielfalt und Inklusion bei der Einstellung diskutieren"
        },
        {
          "text": "Gemeinsam Strategien für eine faire Bewertung entwickeln"
        }
      ],
      "objectives": [
        {
          "text": "Nicks unbewusste Voreingenommenheit im Rekrutierungsprozess ansprechen und inklusive Einstellungspraktiken fördern"
        },
        {
          "text": "Eine konstruktive und lehrreiche Atmosphäre aufrechterhalten"
        }
      ]
    }
  },
  {
    "scenarioId": 25,
    "language": "es-US",
    "translations": {
      "context": "Nick es uno de tus colaboradores directos. Durante las recientes reuniones de evaluación de entrevistas para una nueva contratación, notaste que los comentarios de Nick hacia las candidatas eran significativamente más duros que hacia los candidatos masculinos. \n\nHas programado esta reunión con él para discutir lo que crees que es un sesgo inconsciente. Nick sabe que la reunión es para hablar sobre las entrevistas, pero no sabe que vas a plantear este tema específico.",
      "keyDetails": [
        {
          "text": "Nick mostró sesgo contra las candidatas en entrevistas recientes"
        },
        {
          "text": "Sus puntuaciones y comentarios fueron más duros para las mujeres que para los candidatos masculinos"
        },
        {
          "text": "Hizo comentarios inaceptables durante las reuniones de evaluación de entrevistas"
        },
        {
          "text": "Por ejemplo, comentó que las candidatas pronto desaparecerían para tener hijos"
        },
        {
          "text": "Quieres que Nick comprenda sus sesgos mientras mantienes un ambiente constructivo"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Proporcionar ejemplos específicos del comportamiento sesgado observado"
        },
        {
          "text": "Explicar el concepto de sesgo inconsciente y su impacto"
        },
        {
          "text": "Discutir la importancia de la diversidad y la inclusión en la contratación"
        },
        {
          "text": "Desarrollar colaborativamente estrategias para una evaluación justa"
        }
      ],
      "objectives": [
        {
          "text": "Abordar el sesgo inconsciente de Nick en el proceso de reclutamiento y promover prácticas de contratación inclusivas"
        },
        {
          "text": "Mantener un ambiente constructivo y educativo"
        }
      ]
    }
  },
  {
    "scenarioId": 3,
    "language": "cmn-CN",
    "translations": {
      "context": "下属 Jordan 近期通过电子邮件告知您他正在办理离婚。您已与他安排通话，讨论这一敏感事宜。",
      "keyDetails": [
        {
          "text": "Jordan 近期通过电子邮件告知您他正在办理离婚"
        },
        {
          "text": "他没有提供关于此情况的更多细节"
        },
        {
          "text": "这是一个可能影响工作的敏感个人事宜"
        },
        {
          "text": "保密性和 Jordan 分享信息的舒适度很重要"
        },
        {
          "text": "可能需要制定持续沟通和支持的计划"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "带着同情和支持开始对话"
        },
        {
          "text": "讨论 Jordan 对他工作专注能力的即时担忧"
        },
        {
          "text": "探讨对工作表现或日程安排的潜在影响"
        },
        {
          "text": "讨论保密性和信息分享偏好"
        },
        {
          "text": "建立持续沟通和支持的计划"
        }
      ],
      "objectives": [
        {
          "text": "对 Jordan 的处境表达同情和支持"
        },
        {
          "text": "了解任何即时担忧和潜在的工作影响"
        }
      ]
    }
  },
  {
    "scenarioId": 3,
    "language": "de-DE",
    "translations": {
      "context": "Jordan, ein direkter Mitarbeiter, hat Sie kürzlich per E-Mail darüber informiert, dass er eine Scheidung durchmacht. Sie haben einen Anruf mit ihm vereinbart, um diese sensible Angelegenheit zu besprechen.",
      "keyDetails": [
        {
          "text": "Jordan hat Sie kürzlich per E-Mail über seine Scheidung informiert"
        },
        {
          "text": "Er hat keine weiteren Details zur Situation genannt"
        },
        {
          "text": "Dies ist eine sensible persönliche Angelegenheit, die die Arbeit beeinträchtigen könnte"
        },
        {
          "text": "Vertraulichkeit und Jordans Komfortniveau beim Teilen von Informationen sind wichtig"
        },
        {
          "text": "Ein Plan für fortlaufende Kommunikation und Unterstützung könnte erforderlich sein"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Beginnen Sie das Gespräch mit Empathie und Unterstützung"
        },
        {
          "text": "Besprechen Sie Jordans unmittelbare Bedenken hinsichtlich seiner Konzentrationsfähigkeit bei der Arbeit"
        },
        {
          "text": "Erkunden Sie mögliche Auswirkungen auf die Arbeitsleistung oder den Zeitplan"
        },
        {
          "text": "Besprechen Sie Vertraulichkeit und Präferenzen für den Informationsaustausch"
        },
        {
          "text": "Erstellen Sie einen Plan für fortlaufende Kommunikation und Unterstützung"
        }
      ],
      "objectives": [
        {
          "text": "Drücken Sie Empathie und Unterstützung für Jordans Situation aus"
        },
        {
          "text": "Verstehen Sie unmittelbare Bedenken und mögliche Auswirkungen auf die Arbeit"
        }
      ]
    }
  },
  {
    "scenarioId": 3,
    "language": "es-US",
    "translations": {
      "context": "Jordan, un subalterno directo, le ha informado recientemente por correo electrónico que se está divorciando. Ha programado una llamada con él para discutir este asunto delicado.",
      "keyDetails": [
        {
          "text": "Jordan le informó recientemente sobre su divorcio por correo electrónico"
        },
        {
          "text": "No proporcionó más detalles sobre la situación"
        },
        {
          "text": "Este es un asunto personal delicado que puede afectar el trabajo"
        },
        {
          "text": "La confidencialidad y el nivel de comodidad de Jordan para compartir información son importantes"
        },
        {
          "text": "Es posible que se necesite un plan para la comunicación y el apoyo continuos"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación con empatía y apoyo"
        },
        {
          "text": "Discutir las preocupaciones inmediatas de Jordan sobre su capacidad para concentrarse en el trabajo"
        },
        {
          "text": "Explorar los posibles impactos en el rendimiento o el horario laboral"
        },
        {
          "text": "Discutir la confidencialidad y las preferencias para compartir información"
        },
        {
          "text": "Establecer un plan para la comunicación y el apoyo continuos"
        }
      ],
      "objectives": [
        {
          "text": "Expresar empatía y apoyo por la situación de Jordan"
        },
        {
          "text": "Comprender cualquier preocupación inmediata y el posible impacto en el trabajo"
        }
      ]
    }
  },
  {
    "scenarioId": 4,
    "language": "cmn-CN",
    "translations": {
      "context": "你的直属下属 Cleo 的工作质量显著下降，尤其是在细节方面。这导致了报告和演示文稿中出现错误，影响了团队的声誉和效率。\n\n你已经安排了与 Cleo 会面讨论此事，但尚未告诉 Cleo 会议内容。",
      "keyDetails": [
        {
          "text": "Cleo 的工作质量下降，尤其是在细节方面"
        },
        {
          "text": "例如，她上周的演示文稿中有错误；她几周前的报告中有多处数字错误"
        },
        {
          "text": "这些问题正在影响团队声誉和效率\n"
        },
        {
          "text": "Cleo 过去一直是表现出色且受重视的团队成员"
        },
        {
          "text": "你希望帮助 Cleo 改进并恢复到她平时的水准"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并解释会议目的"
        },
        {
          "text": "提供质量问题的具体例子及其影响"
        },
        {
          "text": "倾听 Cleo 的看法以及她面临的挑战"
        },
        {
          "text": "合作制定改进计划"
        },
        {
          "text": "设定明确的期望和后续步骤"
        }
      ],
      "objectives": [
        {
          "text": "在保持支持性氛围的同时解决工作质量问题"
        },
        {
          "text": "了解绩效下降背后的根本原因"
        }
      ]
    }
  },
  {
    "scenarioId": 4,
    "language": "de-DE",
    "translations": {
      "context": "Cleo, Ihre direkte Mitarbeiterin, hat eine spürbare Abnahme der Arbeitsqualität gezeigt, insbesondere bei ihrer Aufmerksamkeit für Details. Dies hat zu Fehlern in Berichten und Präsentationen geführt, was den Ruf und die Effizienz des Teams beeinträchtigt.  \n\nSie haben ein Treffen mit Cleo vereinbart, um dies zu besprechen, aber Cleo nicht mitgeteilt, worum es bei dem Treffen geht.",
      "keyDetails": [
        {
          "text": "Cleos Arbeitsqualität hat nachgelassen, insbesondere bei der Detailgenauigkeit"
        },
        {
          "text": "Zum Beispiel enthielt ihre Präsentation letzte Woche Fehler; ihr Bericht vor einigen Wochen enthielt mehrere Zahlenfehler"
        },
        {
          "text": "Die Probleme beeinträchtigen den Ruf und die Effizienz des Teams \n"
        },
        {
          "text": "Cleo war historisch gesehen eine leistungsstarke und geschätzte Mitarbeiterin"
        },
        {
          "text": "Sie möchten Cleo helfen, sich zu verbessern und ihren gewohnten Standard wiederzuerlangen"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Treffens erläutern"
        },
        {
          "text": "Spezifische Beispiele für Qualitätsprobleme und deren Auswirkungen nennen"
        },
        {
          "text": "Cleos Perspektive und eventuelle Herausforderungen anhören"
        },
        {
          "text": "Gemeinsam einen Verbesserungsplan entwickeln"
        },
        {
          "text": "Klare Erwartungen und Folgeschritte festlegen"
        }
      ],
      "objectives": [
        {
          "text": "Das Problem der Arbeitsqualität angehen und gleichzeitig eine unterstützende Atmosphäre aufrechterhalten"
        },
        {
          "text": "Die Ursachen für den Leistungsrückgang verstehen"
        }
      ]
    }
  },
  {
    "scenarioId": 4,
    "language": "es-US",
    "translations": {
      "context": "Cleo, su subordinada directa, ha mostrado una disminución notable en la calidad de su trabajo, particularmente en su atención al detalle. Esto ha provocado errores en informes y presentaciones, lo que afecta la reputación y eficiencia del equipo. \n\nHa programado una reunión con Cleo para hablar de esto, pero no le ha comunicado a Cleo de qué se trata la reunión.",
      "keyDetails": [
        {
          "text": "La calidad del trabajo de Cleo ha disminuido, especialmente en la atención al detalle"
        },
        {
          "text": "Por ejemplo, su presentación de la semana pasada contenía errores; su informe de hace unas semanas tenía múltiples errores numéricos"
        },
        {
          "text": "Los problemas están afectando la reputación y la eficiencia del equipo \n"
        },
        {
          "text": "Cleo ha sido históricamente una empleada de alto rendimiento y un miembro valioso del equipo"
        },
        {
          "text": "Quiere ayudar a Cleo a mejorar y a recuperar su nivel habitual"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Proporcionar ejemplos específicos de problemas de calidad y su impacto"
        },
        {
          "text": "Escuchar la perspectiva de Cleo y los desafíos que enfrenta"
        },
        {
          "text": "Colaborar en el desarrollo de un plan de mejora"
        },
        {
          "text": "Establecer expectativas claras y pasos de seguimiento"
        }
      ],
      "objectives": [
        {
          "text": "Abordar el problema de la calidad del trabajo manteniendo un ambiente de apoyo"
        },
        {
          "text": "Comprender las causas fundamentales detrás de la disminución del rendimiento"
        }
      ]
    }
  },
  {
    "scenarioId": 43,
    "language": "cmn-CN",
    "translations": {
      "context": "你团队中一向可靠的成员 Jay，最近在团队会议中表现出明显的烦躁不安，这种反常行为造成了一些紧张气氛。作为他的经理，在观察到这些变化并收到其他团队成员的非正式反馈后，你安排了一次私下会谈。",
      "keyDetails": [
        {
          "text": "Jay 表现良好，但过去几周明显烦躁不安"
        },
        {
          "text": "你已经多次注意到这种变化（例如，上周当团队成员问及他项目状态的正常问题时，他对对方表现出烦躁）"
        },
        {
          "text": "你非常担心，因为这与他平时的性格不符，你想确认他是否安好"
        },
        {
          "text": "你的角色是倾听和支持，而不是纪律处分"
        },
        {
          "text": "你的目标是创造一个安全的空间，让 Jay 感到自在并愿意敞开心扉"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "首先以一般性健康问题开场，建立心理安全感，然后再提及具体的行为表现"
        },
        {
          "text": "从关心的角度，而非批评的角度，分享对行为变化的观察"
        },
        {
          "text": "积极倾听并允许沉默——给 Jay 空间让他自然地敞开心扉"
        },
        {
          "text": "如果 Jay 分享个人挑战，首先侧重于理解，然后再考虑解决方案"
        },
        {
          "text": "以清晰、双方同意的下一步行动结束，同时强调你持续的支持和随时待命"
        }
      ],
      "objectives": [
        {
          "text": "创造一个安全、保密的空间，让 Jay 能够分享任何影响他工作表现的潜在问题"
        },
        {
          "text": "向 Jay 提供支持，并与他达成一致，明确你如何提供帮助"
        }
      ]
    }
  },
  {
    "scenarioId": 43,
    "language": "de-DE",
    "translations": {
      "context": "Ein normalerweise zuverlässiges Mitglied Ihres Teams, Jay, war in den letzten Teambesprechungen merklich reizbar und zeigte ein untypisches Verhalten, das zu Spannungen geführt hat. Als sein Manager haben Sie ein privates Gespräch vereinbart, nachdem Sie diese Veränderungen beobachtet und informelle Bedenken von anderen Teammitgliedern erhalten haben.",
      "keyDetails": [
        {
          "text": "Jay ist ein guter Leistungsträger, war aber in den letzten Wochen merklich reizbar."
        },
        {
          "text": "Sie haben diese Veränderung mehrfach bemerkt (z.B. letzte Woche war er reizbar gegenüber jemandem im Team, als er eine normale Frage zu seinem Projektstatus gestellt bekam)."
        },
        {
          "text": "Sie sind sehr besorgt, da dies untypisch für ihn ist und Sie sicherstellen möchten, dass es ihm gut geht."
        },
        {
          "text": "Ihre Rolle ist es, zuzuhören und zu unterstützen, nicht zu disziplinieren."
        },
        {
          "text": "Ihr Ziel ist es, einen sicheren Raum zu schaffen, damit Jay sich wohlfühlt, sich zu öffnen."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Beginnen Sie mit allgemeinen Fragen zum Wohlbefinden und schaffen Sie psychologische Sicherheit, bevor Sie spezifische Verhaltensweisen ansprechen."
        },
        {
          "text": "Teilen Sie Beobachtungen über Verhaltensänderungen aus einer Haltung der Besorgnis, nicht der Kritik."
        },
        {
          "text": "Hören Sie aktiv zu und lassen Sie Pausen zu – geben Sie Jay Raum, sich natürlich zu öffnen."
        },
        {
          "text": "Wenn Jay persönliche Herausforderungen teilt, konzentrieren Sie sich zuerst auf das Verständnis, bevor Sie zu Lösungen übergehen."
        },
        {
          "text": "Beenden Sie das Gespräch mit klaren, einvernehmlich vereinbarten nächsten Schritten, während Sie Ihre fortlaufende Unterstützung und Verfügbarkeit betonen."
        }
      ],
      "objectives": [
        {
          "text": "Schaffen Sie einen sicheren, vertraulichen Raum, der es Jay ermöglicht, alle zugrunde liegenden Probleme zu teilen, die sein Arbeitsverhalten beeinflussen."
        },
        {
          "text": "Bieten Sie Jay Unterstützung an und stimmen Sie sich mit ihm ab, wie Sie helfen können."
        }
      ]
    }
  },
  {
    "scenarioId": 43,
    "language": "es-US",
    "translations": {
      "context": "Jay, un miembro de su equipo que suele ser confiable, ha estado notablemente irritable en las últimas reuniones de equipo, mostrando un comportamiento inusual que ha generado cierta tensión. Como su gerente, usted ha programado una reunión privada de seguimiento después de observar estos cambios y recibir preocupaciones informales de otros miembros del equipo.",
      "keyDetails": [
        {
          "text": "Jay es un buen empleado, pero ha estado notablemente irritable durante las últimas semanas."
        },
        {
          "text": "Usted ha notado este cambio varias veces (por ejemplo, la semana pasada estuvo irritable con alguien del equipo cuando le hicieron una pregunta normal sobre el estado de su proyecto)."
        },
        {
          "text": "Usted está muy preocupado, ya que esto no es propio de él y quiere asegurarse de que esté bien."
        },
        {
          "text": "Su rol es escuchar y apoyar, no disciplinar."
        },
        {
          "text": "Su objetivo es crear un espacio seguro para que Jay se sienta cómodo abriéndose."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Comience con preguntas generales sobre su bienestar y cree un ambiente de seguridad psicológica antes de mencionar comportamientos específicos."
        },
        {
          "text": "Comparta observaciones sobre los cambios en el comportamiento desde una posición de preocupación, no de crítica."
        },
        {
          "text": "Escuche activamente y permita los silencios; déle a Jay espacio para abrirse naturalmente."
        },
        {
          "text": "Si Jay comparte desafíos personales, concéntrese primero en comprender antes de pasar a las soluciones."
        },
        {
          "text": "Finalice con pasos siguientes claros y mutuamente acordados, mientras enfatiza su apoyo continuo y disponibilidad."
        }
      ],
      "objectives": [
        {
          "text": "Crear un espacio seguro y confidencial que le permita a Jay compartir cualquier problema subyacente que afecte su comportamiento laboral."
        },
        {
          "text": "Ofrecer apoyo a Jay y acordar con él cómo puede ayudarlo."
        }
      ]
    }
  },
  {
    "scenarioId": 5,
    "language": "cmn-CN",
    "translations": {
      "context": "Ollie，您的直属下属，在客户会议中表现不佳，导致了一些尴尬时刻和误解。然而，他在非会议方面的工作表现依然出色。Ollie自信且善于交际，相信自己能够即兴发挥，但他低估了会议准备的重要性。\n\n您已安排与Ollie会面讨论当前情况。Ollie知道您安排的这次谈话是关于昨天的客户会议。",
      "keyDetails": [
        {
          "text": "Ollie在客户会议中表现不佳。"
        },
        {
          "text": "例如，在昨天的会议中，他草率地回答了一些简单的客户问题。在上周的会议中，他没有在会议开始时设定清晰的议程。"
        },
        {
          "text": "他的非会议工作表现依然出色"
        },
        {
          "text": "Ollie自信且善于交际，喜欢即兴发挥"
        },
        {
          "text": "他低估了会议准备的重要性"
        },
        {
          "text": "目标是在不影响其他工作的情况下提高会议表现\n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并解释会议目的"
        },
        {
          "text": "提供会议问题的具体例子及其影响"
        },
        {
          "text": "肯定Ollie在非会议工作方面的优势"
        },
        {
          "text": "讨论会议准备的重要性"
        },
        {
          "text": "合作制定提高会议表现的策略"
        }
      ],
      "objectives": [
        {
          "text": "解决会议表现问题，同时肯定Ollie的优势\n"
        },
        {
          "text": "制定计划以提高Ollie的会议表现"
        }
      ]
    }
  },
  {
    "scenarioId": 5,
    "language": "de-DE",
    "translations": {
      "context": "Ollie, Ihr direkter Mitarbeiter, hat in Kundengesprächen schlecht abgeschnitten, was zu unangenehmen Momenten und Missverständnissen geführt hat. Seine Arbeit außerhalb von Besprechungen ist jedoch weiterhin ausgezeichnet. Ollie ist selbstbewusst und gesellig, glaubt an seine Fähigkeit, spontan zu reagieren, unterschätzt aber die Bedeutung der Besprechungsvorbereitung. \n\nSie haben ein Treffen mit Ollie vereinbart, um die Situation zu besprechen. Ollie weiß, dass das von Ihnen angesetzte Gespräch dazu dient, die gestrige Kundenbesprechung zu erörtern.",
      "keyDetails": [
        {
          "text": "Ollie hat in Kundengesprächen schlecht abgeschnitten."
        },
        {
          "text": "Zum Beispiel hat er gestern in der Besprechung einige einfache Kundenfragen schlecht beantwortet. In der Besprechung letzte Woche hat er zu Beginn kein klares Programm festgelegt."
        },
        {
          "text": "Seine Arbeit außerhalb von Besprechungen ist weiterhin ausgezeichnet."
        },
        {
          "text": "Ollie ist selbstbewusst und gesellig und zieht es vor, spontan zu reagieren."
        },
        {
          "text": "Er unterschätzt die Bedeutung der Besprechungsvorbereitung."
        },
        {
          "text": "Ziel ist es, die Besprechungsleistung zu verbessern, ohne andere Arbeiten zu beeinträchtigen.\n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Treffens erläutern"
        },
        {
          "text": "Spezifische Beispiele für Besprechungsprobleme und deren Auswirkungen nennen"
        },
        {
          "text": "Ollies Stärken in der Arbeit außerhalb von Besprechungen anerkennen"
        },
        {
          "text": "Die Bedeutung der Besprechungsvorbereitung besprechen"
        },
        {
          "text": "Strategien zur Verbesserung der Besprechungsleistung gemeinsam erarbeiten"
        }
      ],
      "objectives": [
        {
          "text": "Besprechungsleistungsprobleme ansprechen und gleichzeitig Ollies Stärken anerkennen\n"
        },
        {
          "text": "Einen Plan zur Verbesserung von Ollies Besprechungsleistung entwickeln"
        }
      ]
    }
  },
  {
    "scenarioId": 5,
    "language": "es-US",
    "translations": {
      "context": "Ollie, su subordinado directo, ha tenido un desempeño deficiente en las reuniones con clientes, lo que ha generado momentos incómodos y malentendidos. Sin embargo, su trabajo fuera de las reuniones sigue siendo excelente. Ollie es seguro de sí mismo y sociable, cree en su capacidad para improvisar, pero subestima la importancia de la preparación de las reuniones. \n\nHa programado una reunión con Ollie para discutir la situación. Ollie sabe que la conversación que ha programado es para discutir la reunión con el cliente de ayer.",
      "keyDetails": [
        {
          "text": "Ollie ha tenido un desempeño deficiente en las reuniones con clientes."
        },
        {
          "text": "Por ejemplo, en la reunión de ayer respondió mal algunas preguntas sencillas de los clientes. En la reunión de la semana pasada no estableció una agenda clara al inicio de la reunión."
        },
        {
          "text": "Su trabajo fuera de las reuniones sigue siendo excelente."
        },
        {
          "text": "Ollie es seguro de sí mismo y sociable, prefiere improvisar."
        },
        {
          "text": "Subestima la importancia de la preparación de las reuniones."
        },
        {
          "text": "El objetivo es mejorar el desempeño en las reuniones sin afectar otro trabajo.\n"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Proporcionar ejemplos específicos de problemas en las reuniones y su impacto"
        },
        {
          "text": "Reconocer las fortalezas de Ollie en el trabajo fuera de las reuniones"
        },
        {
          "text": "Discutir la importancia de la preparación de las reuniones"
        },
        {
          "text": "Colaborar en estrategias para mejorar el desempeño en las reuniones"
        }
      ],
      "objectives": [
        {
          "text": "Abordar los problemas de desempeño en las reuniones reconociendo las fortalezas de Ollie.\n"
        },
        {
          "text": "Desarrollar un plan para mejorar el desempeño de Ollie en las reuniones"
        }
      ]
    }
  },
  {
    "scenarioId": 6,
    "language": "cmn-CN",
    "translations": {
      "context": "Mark，你的直属下属，最近提交的工作表现低于预期标准，存在一些错误。尽管有这些问题，Mark 态度积极，并且通常渴望进步。\\n\\n你已经安排了与 Mark 的会议来讨论这项工作。你没有告诉他会议内容，但你认为他可能已经猜到了。",
      "keyDetails": [
        {
          "text": "Mark 最近的工作存在一些问题"
        },
        {
          "text": "例如，他包含了不相关的研究；分析不完整；并且整体演示流程令人困惑"
        },
        {
          "text": "他的工作质量低于预期标准"
        },
        {
          "text": "Mark 态度非常积极，热爱他的工作"
        },
        {
          "text": "他渴望提高自己的表现"
        },
        {
          "text": "你希望在解决问题的同时保持 Mark 的热情"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并肯定 Mark 的积极态度"
        },
        {
          "text": "解释会议的目的和绩效问题"
        },
        {
          "text": "提供具体的错误示例及其影响"
        },
        {
          "text": "倾听 Mark 的看法以及他面临的任何挑战"
        },
        {
          "text": "合作制定改进计划"
        }
      ],
      "objectives": [
        {
          "text": "解决最近表现不佳的问题，同时肯定 Mark 的积极态度"
        },
        {
          "text": "共同讨论帮助他提高工作质量的方案"
        }
      ]
    }
  },
  {
    "scenarioId": 6,
    "language": "de-DE",
    "translations": {
      "context": "Mark, Ihr direkter Mitarbeiter, hat kürzlich eine Arbeit eingereicht, die unter den erwarteten Standards lag und mehrere Fehler aufwies. Trotz dieser Probleme hat Mark eine positive Einstellung und ist im Allgemeinen bestrebt, sich zu verbessern.  \n\nSie haben ein Treffen mit Mark vereinbart, um diese Arbeit zu besprechen. Sie haben ihm nicht gesagt, worum es bei dem Treffen geht, aber Sie denken, dass er es vielleicht geahnt hat.",
      "keyDetails": [
        {
          "text": "Marks jüngste Arbeit wies mehrere Probleme auf"
        },
        {
          "text": "Zum Beispiel enthielt er irrelevante Recherchen; die Analyse war unvollständig; und der gesamte Präsentationsfluss war verwirrend"
        },
        {
          "text": "Seine Arbeitsqualität lag unter den erwarteten Standards"
        },
        {
          "text": "Mark hat eine sehr positive Einstellung und liebt seinen Job"
        },
        {
          "text": "Er ist bestrebt, seine Leistung zu verbessern"
        },
        {
          "text": "Sie möchten Marks Enthusiasmus aufrechterhalten, während Sie die Probleme ansprechen"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Beginnen Sie das Gespräch und würdigen Sie Marks positive Einstellung"
        },
        {
          "text": "Erläutern Sie den Zweck des Treffens und die Leistungsbedenken"
        },
        {
          "text": "Geben Sie konkrete Beispiele für Fehler und deren Auswirkungen"
        },
        {
          "text": "Hören Sie sich Marks Perspektive und alle Herausforderungen an, denen er gegenübersteht"
        },
        {
          "text": "Arbeiten Sie gemeinsam an der Entwicklung eines Verbesserungsplans"
        }
      ],
      "objectives": [
        {
          "text": "Sprechen Sie die jüngste Minderleistung an und würdigen Sie gleichzeitig Marks positive Einstellung"
        },
        {
          "text": "Besprechen Sie gemeinsam Ideen, um ihm zu helfen, seine Arbeitsqualität zu verbessern"
        }
      ]
    }
  },
  {
    "scenarioId": 6,
    "language": "es-US",
    "translations": {
      "context": "Mark, su subordinado directo, ha presentado recientemente un trabajo que está por debajo del estándar esperado, con varios errores. A pesar de estos problemas, Mark tiene una actitud positiva y generalmente está ansioso por mejorar. \n\nHa programado una reunión con Mark para discutir este trabajo. No le ha dicho de qué se trata la reunión, pero cree que él podría haberlo adivinado. ",
      "keyDetails": [
        {
          "text": "El trabajo reciente de Mark tuvo varios problemas"
        },
        {
          "text": "Por ejemplo, incluyó investigación que no era relevante; el análisis estaba incompleto; y el flujo general de la presentación era confuso"
        },
        {
          "text": "La calidad de su trabajo estaba por debajo de los estándares esperados"
        },
        {
          "text": "Mark tiene una actitud muy positiva y le encanta su trabajo"
        },
        {
          "text": "Está ansioso por mejorar su desempeño"
        },
        {
          "text": "Quiere mantener el entusiasmo de Mark mientras aborda los problemas"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y reconocer la actitud positiva de Mark"
        },
        {
          "text": "Explicar el propósito de la reunión y las preocupaciones sobre el desempeño"
        },
        {
          "text": "Proporcionar ejemplos específicos de errores y su impacto"
        },
        {
          "text": "Escuchar la perspectiva de Mark y cualquier desafío que esté enfrentando"
        },
        {
          "text": "Colaborar en el desarrollo de un plan de mejora"
        }
      ],
      "objectives": [
        {
          "text": "Abordar el bajo rendimiento reciente mientras se reconoce la actitud positiva de Mark"
        },
        {
          "text": "Discutir colaborativamente ideas para ayudarlo a mejorar la calidad de su trabajo"
        }
      ]
    }
  },
  {
    "scenarioId": 7,
    "language": "cmn-CN",
    "translations": {
      "context": "Amelia，一位雄心勃勃的下属，一直在逾越她的职责范围。她未经你事先批准或知晓，就直接向你的老板发送信息，并且还在承担另一位团队成员的部分项目工作。\n\n你已经安排了与Amelia的会议来讨论此情况。你尚未告知Amelia会议的主题。",
      "keyDetails": [
        {
          "text": "Amelia未经你知晓，直接向你的老板发送信息"
        },
        {
          "text": "她未经许可，承担了另一位团队成员（Walt）的部分项目工作"
        },
        {
          "text": "你需要明确她的职责范围"
        },
        {
          "text": "你希望强调正确的沟通渠道"
        },
        {
          "text": "你希望Amelia将重心放回她的核心职责上"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并解释会议目的"
        },
        {
          "text": "提供Amelia越界行为的具体例子"
        },
        {
          "text": "明确职责期望和正确的沟通渠道"
        },
        {
          "text": "倾听Amelia的观点和动机"
        },
        {
          "text": "共同制定一个适当的参与计划"
        }
      ],
      "objectives": [
        {
          "text": "处理Amelia越权行为\n"
        },
        {
          "text": "明确角色期望和适当的沟通渠道"
        }
      ]
    }
  },
  {
    "scenarioId": 7,
    "language": "de-DE",
    "translations": {
      "context": "Amelia, eine ehrgeizige direkte Mitarbeiterin, hat die Grenzen ihrer Rolle überschritten. Sie hat Ihrem Chef Informationen ohne Ihre vorherige Genehmigung oder Kenntnis zukommen lassen und Teile eines Projekts eines anderen Teammitglieds übernommen. \n\nSie haben ein Treffen mit Amelia vereinbart, um die Situation zu besprechen. Sie haben Amelia im Vorfeld nicht über den Zweck des Treffens informiert. ",
      "keyDetails": [
        {
          "text": "Amelia hat Ihrem Chef ohne Ihr Wissen direkt Informationen zukommen lassen"
        },
        {
          "text": "Sie hat ohne Erlaubnis Teile des Projekts eines anderen Teammitglieds (Walt's) übernommen"
        },
        {
          "text": "Sie müssen ihre Rollengrenzen klären"
        },
        {
          "text": "Sie möchten die richtigen Kommunikationskanäle stärken"
        },
        {
          "text": "Sie möchten Amelias Fokus auf ihre Kernaufgaben lenken"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Beginnen Sie das Gespräch und erläutern Sie den Zweck des Treffens"
        },
        {
          "text": "Geben Sie konkrete Beispiele dafür, wie Amelia Grenzen überschritten hat"
        },
        {
          "text": "Klären Sie Rollenerwartungen und richtige Kommunikationskanäle"
        },
        {
          "text": "Hören Sie Amelias Perspektive und Motivationen zu"
        },
        {
          "text": "Entwickeln Sie gemeinsam einen Plan für angemessenes Engagement"
        }
      ],
      "objectives": [
        {
          "text": "Amelias Verhalten, Rollengrenzen zu überschreiten, ansprechen\n"
        },
        {
          "text": "Rollenerwartungen und richtige Kommunikationskanäle klären "
        }
      ]
    }
  },
  {
    "scenarioId": 7,
    "language": "es-US",
    "translations": {
      "context": "Amelia, una ambiciosa subalterna, ha estado excediendo los límites de su rol. Ha estado enviando información a tu jefe sin tu aprobación o conocimiento previo, y ha estado asumiendo partes del proyecto de otro miembro del equipo. \n\nHas programado una reunión con Amelia para discutir la situación. No le has adelantado a Amelia de qué trata la reunión.",
      "keyDetails": [
        {
          "text": "Amelia ha estado enviando información directamente a tu jefe sin tu conocimiento"
        },
        {
          "text": "Ha estado asumiendo partes del proyecto de otro miembro del equipo (Walt) sin permiso"
        },
        {
          "text": "Necesitas aclarar los límites de su rol"
        },
        {
          "text": "Quieres reforzar los canales de comunicación adecuados"
        },
        {
          "text": "Quieres redirigir el enfoque de Amelia hacia sus responsabilidades principales"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Proporcionar ejemplos específicos de Amelia excediendo los límites"
        },
        {
          "text": "Aclarar las expectativas del rol y los canales de comunicación adecuados"
        },
        {
          "text": "Escuchar la perspectiva y motivaciones de Amelia"
        },
        {
          "text": "Desarrollar colaborativamente un plan para un compromiso apropiado"
        }
      ],
      "objectives": [
        {
          "text": "Abordar el comportamiento de Amelia de exceder los límites de su rol\n"
        },
        {
          "text": "Aclarar las expectativas del rol y los canales de comunicación adecuados "
        }
      ]
    }
  },
  {
    "scenarioId": 8,
    "language": "cmn-CN",
    "translations": {
      "context": "你的团队成员 Jasmin 收到了一项欺凌投诉。公司的人力资源政策规定，你需要将这一敏感信息告知她，解释目前不能分享具体细节，并通知她需要在人力资源调查期间休假。你已安排与 Jasmin 会面，告知她目前的情况。",
      "keyDetails": [
        {
          "text": "Jasmin 收到了一项欺凌投诉"
        },
        {
          "text": "目前无法与 Jasmin 分享投诉的进一步细节"
        },
        {
          "text": "Jasmin 需要在调查期间带薪休假"
        },
        {
          "text": "你目前不清楚调查将持续多久"
        },
        {
          "text": "你需要强调遵守人力资源流程的重要性"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "开始对话并解释会议目的"
        },
        {
          "text": "明确说明存在欺凌投诉以及需要休假"
        },
        {
          "text": "解释分享细节的限制"
        },
        {
          "text": "倾听并解决 Jasmin 的即时担忧"
        },
        {
          "text": "提供支持"
        }
      ],
      "objectives": [
        {
          "text": "在保持支持和专业性的同时，告知 Jasmin 欺凌投诉事宜"
        },
        {
          "text": "清晰地解释情况和下一步措施"
        }
      ]
    }
  },
  {
    "scenarioId": 8,
    "language": "de-DE",
    "translations": {
      "context": "Gegen Jasmin, Ihr Teammitglied, wurde eine Mobbing-Beschwerde eingereicht. Die HR-Richtlinien des Unternehmens sehen vor, dass Sie ihr diese sensiblen Informationen mitteilen, erklären, dass Details zu diesem Zeitpunkt nicht geteilt werden können, und sie darüber informieren müssen, dass sie während der HR-Untersuchung freigestellt werden muss. Sie haben ein Treffen mit Jasmin vereinbart, um sie über die Situation zu informieren.",
      "keyDetails": [
        {
          "text": "Gegen Jasmin wurde eine Mobbing-Beschwerde eingereicht"
        },
        {
          "text": "Weitere Details der Beschwerde können Jasmin zu diesem Zeitpunkt nicht mitgeteilt werden"
        },
        {
          "text": "Jasmin muss während der Untersuchung mit voller Bezahlung freigestellt werden"
        },
        {
          "text": "Sie wissen derzeit nicht, wie lange die Untersuchung dauern wird"
        },
        {
          "text": "Sie müssen die Bedeutung der Einhaltung des HR-Prozesses betonen"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Das Gespräch eröffnen und den Zweck des Treffens erläutern"
        },
        {
          "text": "Das Vorhandensein der Mobbing-Beschwerde und die Notwendigkeit einer Freistellung klar darlegen"
        },
        {
          "text": "Die Einschränkungen bezüglich der Weitergabe von Details erläutern"
        },
        {
          "text": "Jasmin's unmittelbare Bedenken anhören und darauf eingehen"
        },
        {
          "text": "Unterstützung anbieten"
        }
      ],
      "objectives": [
        {
          "text": "Jasmin über die Mobbing-Beschwerde informieren, dabei Unterstützung und Professionalität wahren"
        },
        {
          "text": "Die Situation und die nächsten Schritte klar erläutern"
        }
      ]
    }
  },
  {
    "scenarioId": 8,
    "language": "es-US",
    "translations": {
      "context": "Jasmin, su compañera de equipo, ha sido objeto de una queja por acoso. La política de Recursos Humanos de la compañía dicta que usted necesita comunicarle esta información sensible, explicarle que los detalles no pueden compartirse en esta etapa, e informarle que necesita tomarse un tiempo libre durante la investigación de RR. HH. Usted ha programado una reunión con Jasmin para informarle de la situación.",
      "keyDetails": [
        {
          "text": "Se ha presentado una queja por acoso contra Jasmin"
        },
        {
          "text": "No se pueden compartir más detalles de la queja con Jasmin en esta etapa"
        },
        {
          "text": "Jasmin necesita tomarse un tiempo libre del trabajo durante la investigación, con goce de sueldo completo"
        },
        {
          "text": "Actualmente no sabe cuánto tiempo durará la investigación"
        },
        {
          "text": "Debe enfatizar la importancia de seguir el proceso de RR. HH."
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Abrir la conversación y explicar el propósito de la reunión"
        },
        {
          "text": "Indicar claramente la existencia de la queja por acoso y la necesidad de tomar tiempo libre"
        },
        {
          "text": "Explicar las limitaciones para compartir detalles"
        },
        {
          "text": "Escuchar y abordar las preocupaciones inmediatas de Jasmin"
        },
        {
          "text": "Ofrecer apoyo"
        }
      ],
      "objectives": [
        {
          "text": "Informar a Jasmin sobre la queja por acoso manteniendo el apoyo y la profesionalidad"
        },
        {
          "text": "Explicar la situación y los siguientes pasos claramente"
        }
      ]
    }
  },
  {
    "scenarioId": 9,
    "language": "cmn-CN",
    "translations": {
      "context": "Dennis，您团队中一位始终表现出色、成果卓越的明星员工，但人际交往能力较差。他经常对同事粗鲁、生硬，不乐于助人，尤其是对他认为能力不足的同事。\n\n您已安排与Dennis会面以解决此问题。",
      "keyDetails": [
        {
          "text": "Dennis是一位表现出色、成果卓越的员工"
        },
        {
          "text": "他的人际交往能力较差，经常粗鲁、生硬"
        },
        {
          "text": "例如，他拒绝帮助团队成员处理他擅长的任务；当团队中有人对他的演示提出改进建议时，他表现得粗鲁且不屑一顾"
        },
        {
          "text": "他的行为正在影响团队的动力和协作"
        },
        {
          "text": "改善他的行为对他的职业发展至关重要"
        },
        {
          "text": "目标是在保持他高绩效的同时，提升他的团队协作能力"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "通过肯定Dennis的卓越表现来开启对话"
        },
        {
          "text": "提供具体问题行为及其影响的例子（例如，拒绝帮助团队成员处理他擅长的任务；当团队中有人对他的演示提出改进建议时，他表现得粗鲁且不屑一顾）"
        },
        {
          "text": "解释人际交往能力对职业发展的重要性"
        },
        {
          "text": "倾听Dennis对自己行为和工作方式的看法"
        },
        {
          "text": "共同制定改进人际交往能力的策略"
        }
      ],
      "objectives": [
        {
          "text": "解决Dennis的人际交往问题，同时保持他的高绩效和投入度"
        },
        {
          "text": "讨论改进Dennis的行为和领导能力的下一步措施"
        }
      ]
    }
  },
  {
    "scenarioId": 9,
    "language": "de-DE",
    "translations": {
      "context": "Dennis, ein herausragender Mitarbeiter in Ihrem Team, der stets hervorragende Ergebnisse liefert, verfügt über mangelhafte soziale Kompetenzen. Er ist oft unhöflich, schroff und wenig hilfsbereit gegenüber Kollegen, insbesondere gegenüber denen, die er als weniger kompetent empfindet. \n\nSie haben ein Treffen mit Dennis vereinbart, um die Situation zu besprechen.",
      "keyDetails": [
        {
          "text": "Dennis ist ein leistungsstarker Mitarbeiter mit hervorragenden Ergebnissen"
        },
        {
          "text": "Er verfügt über mangelhafte soziale Kompetenzen und ist oft unhöflich und schroff"
        },
        {
          "text": "Zum Beispiel weigerte er sich, Teammitgliedern bei Aufgaben zu helfen, in denen er Expertise besitzt; er war unhöflich und abweisend, als jemand im Team eine Verbesserung für seine Präsentation vorschlug"
        },
        {
          "text": "Sein Verhalten beeinträchtigt die Teamdynamik und Zusammenarbeit"
        },
        {
          "text": "Die Verbesserung seines Verhaltens ist entscheidend für seine berufliche Weiterentwicklung"
        },
        {
          "text": "Das Ziel ist es, seine Leistung zu erhalten und gleichzeitig seine Teamfähigkeiten zu verbessern"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Beginnen Sie das Gespräch, indem Sie Dennis' starke Leistung anerkennen"
        },
        {
          "text": "Geben Sie konkrete Beispiele für problematisches Verhalten und dessen Auswirkungen (z.B. Weigerung, Teammitgliedern bei Aufgaben zu helfen, in denen er Expertise besitzt; unhöfliches und abweisendes Verhalten, wenn jemand im Team eine Verbesserung für seine Präsentation vorschlug)"
        },
        {
          "text": "Erläutern Sie die Bedeutung von sozialen Kompetenzen für die berufliche Weiterentwicklung"
        },
        {
          "text": "Hören Sie Dennis' Perspektive zu seinem Verhalten und Arbeitsstil an"
        },
        {
          "text": "Entwickeln Sie gemeinsam Strategien zur Verbesserung der sozialen Kompetenzen"
        }
      ],
      "objectives": [
        {
          "text": "Dennis' zwischenmenschliche Probleme ansprechen, während seine hohe Leistung und sein Engagement erhalten bleiben"
        },
        {
          "text": "Nächste Schritte zur Verbesserung von Dennis' Verhalten und Führungsqualitäten besprechen"
        }
      ]
    }
  },
  {
    "scenarioId": 9,
    "language": "es-US",
    "translations": {
      "context": "Dennis, un empleado estrella de tu equipo que siempre entrega excelentes resultados, tiene malas habilidades interpersonales. A menudo es grosero, abrasivo y poco colaborador con sus colegas, especialmente con aquellos a quienes percibe como menos competentes. \n\nHas programado una reunión con Dennis para abordar la situación.",
      "keyDetails": [
        {
          "text": "Dennis es un empleado de alto rendimiento con excelentes resultados"
        },
        {
          "text": "Tiene malas habilidades interpersonales, a menudo siendo grosero y abrasivo"
        },
        {
          "text": "Por ejemplo, se negó a ayudar a los miembros del equipo con tareas en las que tiene experiencia; fue grosero y despectivo cuando alguien del equipo sugirió una mejora a su presentación"
        },
        {
          "text": "Su comportamiento está afectando la dinámica y la colaboración del equipo"
        },
        {
          "text": "Mejorar su comportamiento es crucial para su progresión profesional"
        },
        {
          "text": "El objetivo es mantener su rendimiento mientras mejora sus habilidades de trabajo en equipo"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Iniciar la conversación reconociendo el alto rendimiento de Dennis"
        },
        {
          "text": "Proporcionar ejemplos específicos de comportamiento problemático y su impacto (por ejemplo, negarse a ayudar a los miembros del equipo con tareas en las que tiene experiencia; ser grosero y despectivo cuando alguien del equipo sugirió una mejora a su presentación)"
        },
        {
          "text": "Explicar la importancia de las habilidades interpersonales para la progresión profesional"
        },
        {
          "text": "Escuchar la perspectiva de Dennis sobre su comportamiento y estilo de trabajo"
        },
        {
          "text": "Desarrollar colaborativamente estrategias para mejorar las habilidades interpersonales"
        }
      ],
      "objectives": [
        {
          "text": "Abordar los problemas interpersonales de Dennis mientras se mantiene su alto rendimiento y compromiso"
        },
        {
          "text": "Discutir los próximos pasos para mejorar el comportamiento y las habilidades de liderazgo de Dennis"
        }
      ]
    }
  },
  {
    "scenarioId": 3159,
    "language": "de-DE",
    "translations": {
      "context": "Sie sind Consultant bei einer Beratungsgesellschaft und leiten ein kritisches Projekt zur regulatorischen Compliance für einen wichtigen Mandanten. Ihre Hauptansprechpartnerin Mathilde und ihr Team haben die Zuarbeiten, die Ihr Team benötigt, um im Zeitplan zu bleiben, noch nicht geliefert.\n\nSie haben dieses Gespräch angesetzt, um die daraus entstehenden Verzögerungen zu besprechen und den Projektzeitplan neu abzustimmen.",
      "keyDetails": [
        {
          "text": "Das Projekt ist die Implementierung eines regulatorischen Compliance-Frameworks für den Mandanten"
        },
        {
          "text": "Die von beiden Seiten vereinbarte Frist für den Abschluss endet in vier Wochen"
        },
        {
          "text": "Kritische Finanzdaten aus der Vertriebsabteilung des Mandanten waren letzten Freitag fällig, sind aber noch nicht eingegangen"
        },
        {
          "text": "Es handelt sich um eine langjährige, geschätzte Mandantenbeziehung, die Sie unbedingt schützen möchten"
        },
        {
          "text": "Ohne die fehlenden Daten kann Ihr Team nicht mit der Phase der Risikoanalyse beginnen"
        }
      ],
      "suggestedConversationFlow": [
        {
          "text": "Die gemeinsamen Projektziele und die bisher gute Zusammenarbeit bekräftigen"
        },
        {
          "text": "Den aktuellen Stand klar darlegen und dabei auf den ursprünglichen Zeitplan und die ausstehenden Zuarbeiten verweisen"
        },
        {
          "text": "Die direkten Auswirkungen der fehlenden Informationen auf die anstehenden Projektmeilensteine erläutern"
        },
        {
          "text": "Mathilde nach ihrer Sicht auf die Situation und möglichen Ausweichlösungen fragen"
        },
        {
          "text": "Gemeinsam einen überarbeiteten Zeitplan erarbeiten und klare nächste Schritte für beide Seiten festlegen"
        }
      ],
      "objectives": [
        {
          "text": "Den aktuellen Projektstand und die direkten Auswirkungen der Verzögerungen transparent kommunizieren"
        },
        {
          "text": "Gemeinsam mit dem Mandanten Lösungen finden und einen überarbeiteten, realistischen Projektplan erstellen"
        }
      ]
    }
  }
]
